/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ModelMessageFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyIv?: ModelStringInput | null,
  bodyAuthTag?: ModelStringInput | null,
  bodyEncryptedDataKey?: ModelStringInput | null,
  bodySnippet?: ModelStringInput | null,
  status?: ModelStringInput | null,
  scheduledDate?: ModelStringInput | null,
  endOfLifeTrigger?: ModelBooleanInput | null,
  size?: ModelFloatInput | null,
  userprofileID?: ModelIDInput | null,
  sentDate?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMessageFilterInput | null > | null,
  or?: Array< ModelMessageFilterInput | null > | null,
  not?: ModelMessageFilterInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelMessageConnection = {
  __typename: "ModelMessageConnection",
  items:  Array<Message | null >,
  nextToken?: string | null,
};

export type Message = {
  __typename: "Message",
  id: string,
  title?: string | null,
  body: string,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  status?: string | null,
  scheduledDate?: string | null,
  endOfLifeTrigger?: boolean | null,
  size?: number | null,
  userprofileID: string,
  Recipients?: ModelMessageRecipientConnection | null,
  Attachments?: ModelMessageAttachmentConnection | null,
  sentDate?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelMessageRecipientConnection = {
  __typename: "ModelMessageRecipientConnection",
  items:  Array<MessageRecipient | null >,
  nextToken?: string | null,
};

export type MessageRecipient = {
  __typename: "MessageRecipient",
  id: string,
  recipientId: string,
  messageId: string,
  recipient: Recipient,
  message: Message,
  createdAt: string,
  updatedAt: string,
};

export type Recipient = {
  __typename: "Recipient",
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  phoneType?: string | null,
  sendSMS?: boolean | null,
  userprofileID: string,
  messages?: ModelMessageRecipientConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelMessageAttachmentConnection = {
  __typename: "ModelMessageAttachmentConnection",
  items:  Array<MessageAttachment | null >,
  nextToken?: string | null,
};

export type MessageAttachment = {
  __typename: "MessageAttachment",
  id: string,
  messageId: string,
  attachmentId: string,
  message: Message,
  attachment: Attachment,
  createdAt: string,
  updatedAt: string,
};

export type Attachment = {
  __typename: "Attachment",
  id: string,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  status?: string | null,
  size?: number | null,
  s3Key?: string | null,
  uploadDate?: string | null,
  userprofileID: string,
  messages?: ModelMessageAttachmentConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAttachmentFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelStringInput | null,
  status?: ModelStringInput | null,
  size?: ModelFloatInput | null,
  s3Key?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  userprofileID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAttachmentFilterInput | null > | null,
  or?: Array< ModelAttachmentFilterInput | null > | null,
  not?: ModelAttachmentFilterInput | null,
};

export type ModelAttachmentConnection = {
  __typename: "ModelAttachmentConnection",
  items:  Array<Attachment | null >,
  nextToken?: string | null,
};

export type ModelRecipientFilterInput = {
  id?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  phoneType?: ModelStringInput | null,
  sendSMS?: ModelBooleanInput | null,
  userprofileID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelRecipientFilterInput | null > | null,
  or?: Array< ModelRecipientFilterInput | null > | null,
  not?: ModelRecipientFilterInput | null,
};

export type ModelRecipientConnection = {
  __typename: "ModelRecipientConnection",
  items:  Array<Recipient | null >,
  nextToken?: string | null,
};

export type CreateUserInput = {
  id?: string | null,
  cognitoSub?: string | null,
  email: string,
  status?: string | null,
  billingProviderId?: string | null,
  userPlanId?: string | null,
  pendingPlanId?: string | null,
  scheduledPlanId?: string | null,
  planStatus?: string | null,
  planSelectedAt?: string | null,
  planActivatedAt?: string | null,
  checkoutSessionRef?: string | null,
  checkoutMode?: string | null,
  pendingPaymentAmount?: number | null,
  pendingPaymentQuotedAt?: string | null,
  latestPaymentId?: string | null,
  currentPeriodEnd?: string | null,
  billingProvider?: string | null,
  billingCustomerRef?: string | null,
  subscriptionId?: string | null,
};

export type User = {
  __typename: "User",
  id: string,
  cognitoSub?: string | null,
  email: string,
  status?: string | null,
  UserProfile?: UserProfile | null,
  UserPreferences?: UserPreferences | null,
  billingProviderId?: string | null,
  userPlanId?: string | null,
  pendingPlanId?: string | null,
  scheduledPlanId?: string | null,
  planStatus?: string | null,
  planSelectedAt?: string | null,
  planActivatedAt?: string | null,
  checkoutSessionRef?: string | null,
  checkoutMode?: string | null,
  pendingPaymentAmount?: number | null,
  pendingPaymentQuotedAt?: string | null,
  latestPaymentId?: string | null,
  currentPeriodEnd?: string | null,
  billingProvider?: string | null,
  billingCustomerRef?: string | null,
  subscriptionId?: string | null,
  ChangeLogs?: ModelChangeLogConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type UserProfile = {
  __typename: "UserProfile",
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  preferredName?: string | null,
  dateOfBirth?: string | null,
  primaryPhone?: string | null,
  primaryPhoneType?: string | null,
  secondaryPhone?: string | null,
  secondaryPhoneType?: string | null,
  isActive?: boolean | null,
  isAlive?: boolean | null,
  eolVerificationCount?: number | null,
  lastEolVerificationResponseAt?: string | null,
  lastEolVerificationSentAt?: string | null,
  eolVerificationStatus?: EolVerificationStatus | null,
  currentEolVerificationCycleStartedAt?: string | null,
  lastEolVerificationMethod?: EolVerificationMethod | null,
  lastSuccessfulLoginAt?: string | null,
  Messages?: ModelMessageConnection | null,
  Recipients?: ModelRecipientConnection | null,
  Attachments?: ModelAttachmentConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum EolVerificationStatus {
  IN_PROGRESS = "IN_PROGRESS",
  VERIFIED = "VERIFIED",
  RELEASED = "RELEASED",
}


export enum EolVerificationMethod {
  EMAIL_LINK = "EMAIL_LINK",
  SMS_LINK = "SMS_LINK",
  SUCCESSFUL_LOGIN = "SUCCESSFUL_LOGIN",
}


export type UserPreferences = {
  __typename: "UserPreferences",
  id: string,
  eolVerificationIntervalDays?: number | null,
  eolVerificationReminderCount?: number | null,
  eolVerificationReminderIntervalDays?: number | null,
  eolVerificationChannelEmailEnabled?: boolean | null,
  eolVerificationChannelSmsEnabled?: boolean | null,
  eolStopScheduledMessages?: boolean | null,
  minBodyWordCount?: number | null,
  eolAccountReaderRecipientId?: string | null,
  preferredLanguage?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelChangeLogConnection = {
  __typename: "ModelChangeLogConnection",
  items:  Array<ChangeLog | null >,
  nextToken?: string | null,
};

export type ChangeLog = {
  __typename: "ChangeLog",
  id: string,
  requestId: string,
  changedById: string,
  userId: string,
  entityType: ChangeLogEntityType,
  entityId: string,
  changeType: ChangeLogChangeType,
  fieldName?: string | null,
  oldValue?: string | null,
  newValue?: string | null,
  metadata?: string | null,
  dateTime: string,
  createdAt: string,
  updatedAt: string,
};

export enum ChangeLogEntityType {
  MESSAGE = "MESSAGE",
  ATTACHMENT = "ATTACHMENT",
  RECIPIENT = "RECIPIENT",
  PROFILE = "PROFILE",
  PREFERENCES = "PREFERENCES",
  BILLING = "BILLING",
}


export enum ChangeLogChangeType {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  ABANDON = "ABANDON",
  DELETE = "DELETE",
}


export type CreateUserPreferencesInput = {
  id?: string | null,
  eolVerificationIntervalDays?: number | null,
  eolVerificationReminderCount?: number | null,
  eolVerificationReminderIntervalDays?: number | null,
  eolVerificationChannelEmailEnabled?: boolean | null,
  eolVerificationChannelSmsEnabled?: boolean | null,
  eolStopScheduledMessages?: boolean | null,
  minBodyWordCount?: number | null,
  eolAccountReaderRecipientId?: string | null,
  preferredLanguage?: string | null,
};

export type UpdateUserPreferencesInput = {
  id: string,
  eolVerificationIntervalDays?: number | null,
  eolVerificationReminderCount?: number | null,
  eolVerificationReminderIntervalDays?: number | null,
  eolVerificationChannelEmailEnabled?: boolean | null,
  eolVerificationChannelSmsEnabled?: boolean | null,
  eolStopScheduledMessages?: boolean | null,
  minBodyWordCount?: number | null,
  eolAccountReaderRecipientId?: string | null,
  preferredLanguage?: string | null,
};

export type EolVerificationConfirmResult = {
  __typename: "EolVerificationConfirmResult",
  outcome: EolVerificationConfirmOutcome,
};

export enum EolVerificationConfirmOutcome {
  SUCCESS = "SUCCESS",
  LINK_EXPIRED = "LINK_EXPIRED",
  ALREADY_VERIFIED = "ALREADY_VERIFIED",
  INVALID_LINK = "INVALID_LINK",
}


export type CreateDeliveredMessagesInput = {
  id?: string | null,
  recipientEmail: string,
  recipientId?: string | null,
  recipientUserId?: string | null,
  deliveredAt?: string | null,
  deliveryType: string,
  messageRead?: boolean | null,
  readReminderCount?: number | null,
  readReminderStatus?: string | null,
  status: string,
  failureReason?: string | null,
  attemptCount?: number | null,
  lastAttemptAt?: string | null,
  statusUpdatedAt?: string | null,
  fromUserProfileId?: string | null,
  fromName: string,
  fromEmail?: string | null,
  originalMessageId?: string | null,
  title: string,
  body: string,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  hasAttachment: boolean,
  attachmentCount: number,
};

export type ModelDeliveredMessagesConditionInput = {
  recipientEmail?: ModelStringInput | null,
  recipientId?: ModelIDInput | null,
  recipientUserId?: ModelIDInput | null,
  deliveredAt?: ModelStringInput | null,
  deliveryType?: ModelStringInput | null,
  messageRead?: ModelBooleanInput | null,
  readReminderCount?: ModelIntInput | null,
  readReminderStatus?: ModelStringInput | null,
  status?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  attemptCount?: ModelIntInput | null,
  lastAttemptAt?: ModelStringInput | null,
  statusUpdatedAt?: ModelStringInput | null,
  fromUserProfileId?: ModelIDInput | null,
  fromName?: ModelStringInput | null,
  fromEmail?: ModelStringInput | null,
  originalMessageId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyIv?: ModelStringInput | null,
  bodyAuthTag?: ModelStringInput | null,
  bodyEncryptedDataKey?: ModelStringInput | null,
  bodySnippet?: ModelStringInput | null,
  hasAttachment?: ModelBooleanInput | null,
  attachmentCount?: ModelIntInput | null,
  and?: Array< ModelDeliveredMessagesConditionInput | null > | null,
  or?: Array< ModelDeliveredMessagesConditionInput | null > | null,
  not?: ModelDeliveredMessagesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type DeliveredMessages = {
  __typename: "DeliveredMessages",
  id: string,
  recipientEmail: string,
  recipientId?: string | null,
  recipientUserId?: string | null,
  deliveredAt?: string | null,
  deliveryType: string,
  messageRead?: boolean | null,
  readReminderCount?: number | null,
  readReminderStatus?: string | null,
  status: string,
  failureReason?: string | null,
  attemptCount?: number | null,
  lastAttemptAt?: string | null,
  statusUpdatedAt?: string | null,
  fromUserProfileId?: string | null,
  fromName: string,
  fromEmail?: string | null,
  originalMessageId?: string | null,
  title: string,
  body: string,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  hasAttachment: boolean,
  attachmentCount: number,
  attachmentsCopiedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDeliveredMessagesInput = {
  id: string,
  recipientEmail?: string | null,
  recipientId?: string | null,
  recipientUserId?: string | null,
  deliveredAt?: string | null,
  deliveryType?: string | null,
  messageRead?: boolean | null,
  readReminderCount?: number | null,
  readReminderStatus?: string | null,
  status?: string | null,
  failureReason?: string | null,
  attemptCount?: number | null,
  lastAttemptAt?: string | null,
  statusUpdatedAt?: string | null,
  fromUserProfileId?: string | null,
  fromName?: string | null,
  fromEmail?: string | null,
  originalMessageId?: string | null,
  title?: string | null,
  body?: string | null,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  hasAttachment?: boolean | null,
  attachmentCount?: number | null,
};

export type DeleteDeliveredMessagesInput = {
  id: string,
};

export type CreateDeliveredMessagesAttachmentsInput = {
  id?: string | null,
  deliveredMessageId: string,
  recipientEmail: string,
  fileName: string,
  fileType?: string | null,
  fileSize?: number | null,
  s3Key: string,
  uploadedAt?: string | null,
};

export type ModelDeliveredMessagesAttachmentsConditionInput = {
  deliveredMessageId?: ModelIDInput | null,
  recipientEmail?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  s3Key?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  and?: Array< ModelDeliveredMessagesAttachmentsConditionInput | null > | null,
  or?: Array< ModelDeliveredMessagesAttachmentsConditionInput | null > | null,
  not?: ModelDeliveredMessagesAttachmentsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DeliveredMessagesAttachments = {
  __typename: "DeliveredMessagesAttachments",
  id: string,
  deliveredMessageId: string,
  recipientEmail: string,
  fileName: string,
  fileType?: string | null,
  fileSize?: number | null,
  s3Key: string,
  uploadedAt?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDeliveredMessagesAttachmentsInput = {
  id: string,
  deliveredMessageId?: string | null,
  recipientEmail?: string | null,
  fileName?: string | null,
  fileType?: string | null,
  fileSize?: number | null,
  s3Key?: string | null,
  uploadedAt?: string | null,
};

export type DeleteDeliveredMessagesAttachmentsInput = {
  id: string,
};

export type CreateMessageDeliveryLogInput = {
  id?: string | null,
  executionId: string,
  actionType: string,
  entityType: string,
  entityId: string,
  originalMessageId?: string | null,
  deliveredMessageId?: string | null,
  recipientId?: string | null,
  previousStatus?: string | null,
  newStatus?: string | null,
  attemptNumber?: number | null,
  errorSummary?: string | null,
  changedFields?: string | null,
  timestamp: string,
  functionName: string,
  details?: string | null,
};

export type ModelMessageDeliveryLogConditionInput = {
  executionId?: ModelStringInput | null,
  actionType?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  originalMessageId?: ModelIDInput | null,
  deliveredMessageId?: ModelIDInput | null,
  recipientId?: ModelIDInput | null,
  previousStatus?: ModelStringInput | null,
  newStatus?: ModelStringInput | null,
  attemptNumber?: ModelIntInput | null,
  errorSummary?: ModelStringInput | null,
  changedFields?: ModelStringInput | null,
  timestamp?: ModelStringInput | null,
  functionName?: ModelStringInput | null,
  details?: ModelStringInput | null,
  and?: Array< ModelMessageDeliveryLogConditionInput | null > | null,
  or?: Array< ModelMessageDeliveryLogConditionInput | null > | null,
  not?: ModelMessageDeliveryLogConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type MessageDeliveryLog = {
  __typename: "MessageDeliveryLog",
  id: string,
  executionId: string,
  actionType: string,
  entityType: string,
  entityId: string,
  originalMessageId?: string | null,
  deliveredMessageId?: string | null,
  recipientId?: string | null,
  previousStatus?: string | null,
  newStatus?: string | null,
  attemptNumber?: number | null,
  errorSummary?: string | null,
  changedFields?: string | null,
  timestamp: string,
  functionName: string,
  details?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMessageDeliveryLogInput = {
  id: string,
  executionId?: string | null,
  actionType?: string | null,
  entityType?: string | null,
  entityId?: string | null,
  originalMessageId?: string | null,
  deliveredMessageId?: string | null,
  recipientId?: string | null,
  previousStatus?: string | null,
  newStatus?: string | null,
  attemptNumber?: number | null,
  errorSummary?: string | null,
  changedFields?: string | null,
  timestamp?: string | null,
  functionName?: string | null,
  details?: string | null,
};

export type DeleteMessageDeliveryLogInput = {
  id: string,
};

export type CreateTestimonialsInput = {
  id?: string | null,
  Name?: string | null,
  Location?: string | null,
  Comment?: string | null,
  Active?: boolean | null,
};

export type ModelTestimonialsConditionInput = {
  Name?: ModelStringInput | null,
  Location?: ModelStringInput | null,
  Comment?: ModelStringInput | null,
  Active?: ModelBooleanInput | null,
  and?: Array< ModelTestimonialsConditionInput | null > | null,
  or?: Array< ModelTestimonialsConditionInput | null > | null,
  not?: ModelTestimonialsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Testimonials = {
  __typename: "Testimonials",
  id: string,
  Name?: string | null,
  Location?: string | null,
  Comment?: string | null,
  Active?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTestimonialsInput = {
  id: string,
  Name?: string | null,
  Location?: string | null,
  Comment?: string | null,
  Active?: boolean | null,
};

export type DeleteTestimonialsInput = {
  id: string,
};

export type ModelUserConditionInput = {
  cognitoSub?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  billingProviderId?: ModelIDInput | null,
  userPlanId?: ModelIDInput | null,
  pendingPlanId?: ModelIDInput | null,
  scheduledPlanId?: ModelIDInput | null,
  planStatus?: ModelStringInput | null,
  planSelectedAt?: ModelStringInput | null,
  planActivatedAt?: ModelStringInput | null,
  checkoutSessionRef?: ModelStringInput | null,
  checkoutMode?: ModelStringInput | null,
  pendingPaymentAmount?: ModelFloatInput | null,
  pendingPaymentQuotedAt?: ModelStringInput | null,
  latestPaymentId?: ModelStringInput | null,
  currentPeriodEnd?: ModelStringInput | null,
  billingProvider?: ModelStringInput | null,
  billingCustomerRef?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateUserInput = {
  id: string,
  cognitoSub?: string | null,
  email?: string | null,
  status?: string | null,
  billingProviderId?: string | null,
  userPlanId?: string | null,
  pendingPlanId?: string | null,
  scheduledPlanId?: string | null,
  planStatus?: string | null,
  planSelectedAt?: string | null,
  planActivatedAt?: string | null,
  checkoutSessionRef?: string | null,
  checkoutMode?: string | null,
  pendingPaymentAmount?: number | null,
  pendingPaymentQuotedAt?: string | null,
  latestPaymentId?: string | null,
  currentPeriodEnd?: string | null,
  billingProvider?: string | null,
  billingCustomerRef?: string | null,
  subscriptionId?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateUserProfileInput = {
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  preferredName?: string | null,
  dateOfBirth?: string | null,
  primaryPhone?: string | null,
  primaryPhoneType?: string | null,
  secondaryPhone?: string | null,
  secondaryPhoneType?: string | null,
  isActive?: boolean | null,
  isAlive?: boolean | null,
  eolVerificationCount?: number | null,
  lastEolVerificationResponseAt?: string | null,
  lastEolVerificationSentAt?: string | null,
  eolVerificationStatus?: EolVerificationStatus | null,
  currentEolVerificationCycleStartedAt?: string | null,
  lastEolVerificationMethod?: EolVerificationMethod | null,
  lastSuccessfulLoginAt?: string | null,
};

export type ModelUserProfileConditionInput = {
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  preferredName?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  primaryPhone?: ModelStringInput | null,
  primaryPhoneType?: ModelStringInput | null,
  secondaryPhone?: ModelStringInput | null,
  secondaryPhoneType?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  isAlive?: ModelBooleanInput | null,
  eolVerificationCount?: ModelIntInput | null,
  lastEolVerificationResponseAt?: ModelStringInput | null,
  lastEolVerificationSentAt?: ModelStringInput | null,
  eolVerificationStatus?: ModelEolVerificationStatusInput | null,
  currentEolVerificationCycleStartedAt?: ModelStringInput | null,
  lastEolVerificationMethod?: ModelEolVerificationMethodInput | null,
  lastSuccessfulLoginAt?: ModelStringInput | null,
  and?: Array< ModelUserProfileConditionInput | null > | null,
  or?: Array< ModelUserProfileConditionInput | null > | null,
  not?: ModelUserProfileConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEolVerificationStatusInput = {
  eq?: EolVerificationStatus | null,
  ne?: EolVerificationStatus | null,
};

export type ModelEolVerificationMethodInput = {
  eq?: EolVerificationMethod | null,
  ne?: EolVerificationMethod | null,
};

export type UpdateUserProfileInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  preferredName?: string | null,
  dateOfBirth?: string | null,
  primaryPhone?: string | null,
  primaryPhoneType?: string | null,
  secondaryPhone?: string | null,
  secondaryPhoneType?: string | null,
  isActive?: boolean | null,
  isAlive?: boolean | null,
  eolVerificationCount?: number | null,
  lastEolVerificationResponseAt?: string | null,
  lastEolVerificationSentAt?: string | null,
  eolVerificationStatus?: EolVerificationStatus | null,
  currentEolVerificationCycleStartedAt?: string | null,
  lastEolVerificationMethod?: EolVerificationMethod | null,
  lastSuccessfulLoginAt?: string | null,
};

export type DeleteUserProfileInput = {
  id: string,
};

export type ModelUserPreferencesConditionInput = {
  eolVerificationIntervalDays?: ModelIntInput | null,
  eolVerificationReminderCount?: ModelIntInput | null,
  eolVerificationReminderIntervalDays?: ModelIntInput | null,
  eolVerificationChannelEmailEnabled?: ModelBooleanInput | null,
  eolVerificationChannelSmsEnabled?: ModelBooleanInput | null,
  eolStopScheduledMessages?: ModelBooleanInput | null,
  minBodyWordCount?: ModelIntInput | null,
  eolAccountReaderRecipientId?: ModelIDInput | null,
  preferredLanguage?: ModelStringInput | null,
  and?: Array< ModelUserPreferencesConditionInput | null > | null,
  or?: Array< ModelUserPreferencesConditionInput | null > | null,
  not?: ModelUserPreferencesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type DeleteUserPreferencesInput = {
  id: string,
};

export type CreateEolVerificationTokenInput = {
  id?: string | null,
  userId: string,
  cycleId: string,
  tokenHash: string,
  status: EolVerificationTokenStatus,
  issuedAt: string,
  expiresAt: string,
  usedAt?: string | null,
  channel: EolVerificationChannel,
};

export enum EolVerificationTokenStatus {
  ACTIVE = "ACTIVE",
  USED = "USED",
  EXPIRED = "EXPIRED",
  INVALIDATED = "INVALIDATED",
}


export enum EolVerificationChannel {
  EMAIL = "EMAIL",
  SMS = "SMS",
}


export type ModelEolVerificationTokenConditionInput = {
  userId?: ModelIDInput | null,
  cycleId?: ModelStringInput | null,
  tokenHash?: ModelStringInput | null,
  status?: ModelEolVerificationTokenStatusInput | null,
  issuedAt?: ModelStringInput | null,
  expiresAt?: ModelStringInput | null,
  usedAt?: ModelStringInput | null,
  channel?: ModelEolVerificationChannelInput | null,
  and?: Array< ModelEolVerificationTokenConditionInput | null > | null,
  or?: Array< ModelEolVerificationTokenConditionInput | null > | null,
  not?: ModelEolVerificationTokenConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelEolVerificationTokenStatusInput = {
  eq?: EolVerificationTokenStatus | null,
  ne?: EolVerificationTokenStatus | null,
};

export type ModelEolVerificationChannelInput = {
  eq?: EolVerificationChannel | null,
  ne?: EolVerificationChannel | null,
};

export type EolVerificationToken = {
  __typename: "EolVerificationToken",
  id: string,
  userId: string,
  cycleId: string,
  tokenHash: string,
  status: EolVerificationTokenStatus,
  issuedAt: string,
  expiresAt: string,
  usedAt?: string | null,
  channel: EolVerificationChannel,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEolVerificationTokenInput = {
  id: string,
  userId?: string | null,
  cycleId?: string | null,
  tokenHash?: string | null,
  status?: EolVerificationTokenStatus | null,
  issuedAt?: string | null,
  expiresAt?: string | null,
  usedAt?: string | null,
  channel?: EolVerificationChannel | null,
};

export type DeleteEolVerificationTokenInput = {
  id: string,
};

export type CreateRecipientInput = {
  id?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  phoneType?: string | null,
  sendSMS?: boolean | null,
  userprofileID: string,
};

export type ModelRecipientConditionInput = {
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  email?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  phoneType?: ModelStringInput | null,
  sendSMS?: ModelBooleanInput | null,
  userprofileID?: ModelIDInput | null,
  and?: Array< ModelRecipientConditionInput | null > | null,
  or?: Array< ModelRecipientConditionInput | null > | null,
  not?: ModelRecipientConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateRecipientInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  phoneType?: string | null,
  sendSMS?: boolean | null,
  userprofileID?: string | null,
};

export type DeleteRecipientInput = {
  id: string,
};

export type CreateRecipientWithPlatformGuardsInput = {
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  phone?: string | null,
  phoneType?: string | null,
  sendSMS?: boolean | null,
};

export type CreateMessageInput = {
  id?: string | null,
  title?: string | null,
  body: string,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  status?: string | null,
  scheduledDate?: string | null,
  endOfLifeTrigger?: boolean | null,
  size?: number | null,
  userprofileID: string,
  sentDate?: string | null,
};

export type ModelMessageConditionInput = {
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyIv?: ModelStringInput | null,
  bodyAuthTag?: ModelStringInput | null,
  bodyEncryptedDataKey?: ModelStringInput | null,
  bodySnippet?: ModelStringInput | null,
  status?: ModelStringInput | null,
  scheduledDate?: ModelStringInput | null,
  endOfLifeTrigger?: ModelBooleanInput | null,
  size?: ModelFloatInput | null,
  userprofileID?: ModelIDInput | null,
  sentDate?: ModelStringInput | null,
  and?: Array< ModelMessageConditionInput | null > | null,
  or?: Array< ModelMessageConditionInput | null > | null,
  not?: ModelMessageConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateMessageInput = {
  id: string,
  title?: string | null,
  body?: string | null,
  bodyIv?: string | null,
  bodyAuthTag?: string | null,
  bodyEncryptedDataKey?: string | null,
  bodySnippet?: string | null,
  status?: string | null,
  scheduledDate?: string | null,
  endOfLifeTrigger?: boolean | null,
  size?: number | null,
  userprofileID?: string | null,
  sentDate?: string | null,
};

export type DeleteMessageInput = {
  id: string,
};

export type CreatePlanInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  price?: number | null,
  billingCycle?: string | null,
  status?: string | null,
  messagesAllowed?: number | null,
  attachmentsAllowed?: number | null,
  recipientsAllowed?: number | null,
  billingProviderId?: string | null,
  checkoutMode?: string | null,
  priceId?: string | null,
  billingConfig?: string | null,
};

export type ModelPlanConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  billingCycle?: ModelStringInput | null,
  status?: ModelStringInput | null,
  messagesAllowed?: ModelIntInput | null,
  attachmentsAllowed?: ModelIntInput | null,
  recipientsAllowed?: ModelIntInput | null,
  billingProviderId?: ModelIDInput | null,
  checkoutMode?: ModelStringInput | null,
  priceId?: ModelStringInput | null,
  billingConfig?: ModelStringInput | null,
  and?: Array< ModelPlanConditionInput | null > | null,
  or?: Array< ModelPlanConditionInput | null > | null,
  not?: ModelPlanConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Plan = {
  __typename: "Plan",
  id: string,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  price?: number | null,
  billingCycle?: string | null,
  status?: string | null,
  messagesAllowed?: number | null,
  attachmentsAllowed?: number | null,
  recipientsAllowed?: number | null,
  billingProviderId?: string | null,
  checkoutMode?: string | null,
  priceId?: string | null,
  billingConfig?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePlanInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  price?: number | null,
  billingCycle?: string | null,
  status?: string | null,
  messagesAllowed?: number | null,
  attachmentsAllowed?: number | null,
  recipientsAllowed?: number | null,
  billingProviderId?: string | null,
  checkoutMode?: string | null,
  priceId?: string | null,
  billingConfig?: string | null,
};

export type DeletePlanInput = {
  id: string,
};

export type CreateBillingProviderInput = {
  id?: string | null,
  billingProviderId?: string | null,
  billingProviderName?: string | null,
  providerCode?: string | null,
  isActive?: boolean | null,
  checkoutMode?: string | null,
  webhookEnabled?: boolean | null,
  apiBaseUrl?: string | null,
};

export type ModelBillingProviderConditionInput = {
  billingProviderId?: ModelStringInput | null,
  billingProviderName?: ModelStringInput | null,
  providerCode?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  checkoutMode?: ModelStringInput | null,
  webhookEnabled?: ModelBooleanInput | null,
  apiBaseUrl?: ModelStringInput | null,
  and?: Array< ModelBillingProviderConditionInput | null > | null,
  or?: Array< ModelBillingProviderConditionInput | null > | null,
  not?: ModelBillingProviderConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BillingProvider = {
  __typename: "BillingProvider",
  id: string,
  billingProviderId?: string | null,
  billingProviderName?: string | null,
  providerCode?: string | null,
  isActive?: boolean | null,
  checkoutMode?: string | null,
  webhookEnabled?: boolean | null,
  apiBaseUrl?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBillingProviderInput = {
  id: string,
  billingProviderId?: string | null,
  billingProviderName?: string | null,
  providerCode?: string | null,
  isActive?: boolean | null,
  checkoutMode?: string | null,
  webhookEnabled?: boolean | null,
  apiBaseUrl?: string | null,
};

export type DeleteBillingProviderInput = {
  id: string,
};

export type CreateAttachmentInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  status?: string | null,
  size?: number | null,
  s3Key?: string | null,
  uploadDate?: string | null,
  userprofileID: string,
};

export type ModelAttachmentConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelStringInput | null,
  status?: ModelStringInput | null,
  size?: ModelFloatInput | null,
  s3Key?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  userprofileID?: ModelIDInput | null,
  and?: Array< ModelAttachmentConditionInput | null > | null,
  or?: Array< ModelAttachmentConditionInput | null > | null,
  not?: ModelAttachmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAttachmentInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  type?: string | null,
  status?: string | null,
  size?: number | null,
  s3Key?: string | null,
  uploadDate?: string | null,
  userprofileID?: string | null,
};

export type DeleteAttachmentInput = {
  id: string,
};

export type CreateChangeLogInput = {
  id?: string | null,
  requestId: string,
  changedById: string,
  userId: string,
  entityType: ChangeLogEntityType,
  entityId: string,
  changeType: ChangeLogChangeType,
  fieldName?: string | null,
  oldValue?: string | null,
  newValue?: string | null,
  metadata?: string | null,
  dateTime: string,
};

export type ModelChangeLogConditionInput = {
  requestId?: ModelStringInput | null,
  changedById?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  entityType?: ModelChangeLogEntityTypeInput | null,
  entityId?: ModelIDInput | null,
  changeType?: ModelChangeLogChangeTypeInput | null,
  fieldName?: ModelStringInput | null,
  oldValue?: ModelStringInput | null,
  newValue?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  dateTime?: ModelStringInput | null,
  and?: Array< ModelChangeLogConditionInput | null > | null,
  or?: Array< ModelChangeLogConditionInput | null > | null,
  not?: ModelChangeLogConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelChangeLogEntityTypeInput = {
  eq?: ChangeLogEntityType | null,
  ne?: ChangeLogEntityType | null,
};

export type ModelChangeLogChangeTypeInput = {
  eq?: ChangeLogChangeType | null,
  ne?: ChangeLogChangeType | null,
};

export type UpdateChangeLogInput = {
  id: string,
  requestId?: string | null,
  changedById?: string | null,
  userId?: string | null,
  entityType?: ChangeLogEntityType | null,
  entityId?: string | null,
  changeType?: ChangeLogChangeType | null,
  fieldName?: string | null,
  oldValue?: string | null,
  newValue?: string | null,
  metadata?: string | null,
  dateTime?: string | null,
};

export type DeleteChangeLogInput = {
  id: string,
};

export type CreateLegalAcceptanceInput = {
  id?: string | null,
  userId: string,
  version: string,
  acceptedAt: string,
  sessionId: string,
  sourceApp: string,
  clientType: LoginClientType,
  browser: string,
  os: string,
  userAgent: string,
};

export enum LoginClientType {
  DESKTOP_WEB = "DESKTOP_WEB",
  MOBILE_WEB = "MOBILE_WEB",
  TABLET_WEB = "TABLET_WEB",
}


export type ModelLegalAcceptanceConditionInput = {
  userId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  acceptedAt?: ModelStringInput | null,
  sessionId?: ModelStringInput | null,
  sourceApp?: ModelStringInput | null,
  clientType?: ModelLoginClientTypeInput | null,
  browser?: ModelStringInput | null,
  os?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  and?: Array< ModelLegalAcceptanceConditionInput | null > | null,
  or?: Array< ModelLegalAcceptanceConditionInput | null > | null,
  not?: ModelLegalAcceptanceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLoginClientTypeInput = {
  eq?: LoginClientType | null,
  ne?: LoginClientType | null,
};

export type LegalAcceptance = {
  __typename: "LegalAcceptance",
  id: string,
  userId: string,
  version: string,
  acceptedAt: string,
  sessionId: string,
  sourceApp: string,
  clientType: LoginClientType,
  browser: string,
  os: string,
  userAgent: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLegalAcceptanceInput = {
  id: string,
  userId?: string | null,
  version?: string | null,
  acceptedAt?: string | null,
  sessionId?: string | null,
  sourceApp?: string | null,
  clientType?: LoginClientType | null,
  browser?: string | null,
  os?: string | null,
  userAgent?: string | null,
};

export type DeleteLegalAcceptanceInput = {
  id: string,
};

export type CreateLoginEventInput = {
  id?: string | null,
  userId: string,
  eventType: LoginEventType,
  occurredAt: string,
  sessionId: string,
  sourceApp: string,
  clientType: LoginClientType,
  browser: string,
  os: string,
  userAgent: string,
  authMethod: string,
  mfaUsed: boolean,
  ipHash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
};

export enum LoginEventType {
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGOUT = "LOGOUT",
  LOGOUT_TIMEOUT = "LOGOUT_TIMEOUT",
}


export type ModelLoginEventConditionInput = {
  userId?: ModelIDInput | null,
  eventType?: ModelLoginEventTypeInput | null,
  occurredAt?: ModelStringInput | null,
  sessionId?: ModelStringInput | null,
  sourceApp?: ModelStringInput | null,
  clientType?: ModelLoginClientTypeInput | null,
  browser?: ModelStringInput | null,
  os?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  authMethod?: ModelStringInput | null,
  mfaUsed?: ModelBooleanInput | null,
  ipHash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  and?: Array< ModelLoginEventConditionInput | null > | null,
  or?: Array< ModelLoginEventConditionInput | null > | null,
  not?: ModelLoginEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLoginEventTypeInput = {
  eq?: LoginEventType | null,
  ne?: LoginEventType | null,
};

export type LoginEvent = {
  __typename: "LoginEvent",
  id: string,
  userId: string,
  eventType: LoginEventType,
  occurredAt: string,
  sessionId: string,
  sourceApp: string,
  clientType: LoginClientType,
  browser: string,
  os: string,
  userAgent: string,
  authMethod: string,
  mfaUsed: boolean,
  ipHash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLoginEventInput = {
  id: string,
  userId?: string | null,
  eventType?: LoginEventType | null,
  occurredAt?: string | null,
  sessionId?: string | null,
  sourceApp?: string | null,
  clientType?: LoginClientType | null,
  browser?: string | null,
  os?: string | null,
  userAgent?: string | null,
  authMethod?: string | null,
  mfaUsed?: boolean | null,
  ipHash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
};

export type DeleteLoginEventInput = {
  id: string,
};

export type CreateBillingEventLogInput = {
  id?: string | null,
  userId: string,
  provider: string,
  providerEventId: string,
  providerCustomerRef?: string | null,
  providerResourceRef?: string | null,
  eventType: string,
  status: string,
  planId?: string | null,
  amount?: number | null,
  currency?: string | null,
  occurredAt?: string | null,
  receivedAt: string,
  processedAt?: string | null,
  message?: string | null,
  rawPayload?: string | null,
};

export type ModelBillingEventLogConditionInput = {
  userId?: ModelIDInput | null,
  provider?: ModelStringInput | null,
  providerEventId?: ModelStringInput | null,
  providerCustomerRef?: ModelStringInput | null,
  providerResourceRef?: ModelStringInput | null,
  eventType?: ModelStringInput | null,
  status?: ModelStringInput | null,
  planId?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  occurredAt?: ModelStringInput | null,
  receivedAt?: ModelStringInput | null,
  processedAt?: ModelStringInput | null,
  message?: ModelStringInput | null,
  rawPayload?: ModelStringInput | null,
  and?: Array< ModelBillingEventLogConditionInput | null > | null,
  or?: Array< ModelBillingEventLogConditionInput | null > | null,
  not?: ModelBillingEventLogConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type BillingEventLog = {
  __typename: "BillingEventLog",
  id: string,
  userId: string,
  provider: string,
  providerEventId: string,
  providerCustomerRef?: string | null,
  providerResourceRef?: string | null,
  eventType: string,
  status: string,
  planId?: string | null,
  amount?: number | null,
  currency?: string | null,
  occurredAt?: string | null,
  receivedAt: string,
  processedAt?: string | null,
  message?: string | null,
  rawPayload?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateBillingEventLogInput = {
  id: string,
  userId?: string | null,
  provider?: string | null,
  providerEventId?: string | null,
  providerCustomerRef?: string | null,
  providerResourceRef?: string | null,
  eventType?: string | null,
  status?: string | null,
  planId?: string | null,
  amount?: number | null,
  currency?: string | null,
  occurredAt?: string | null,
  receivedAt?: string | null,
  processedAt?: string | null,
  message?: string | null,
  rawPayload?: string | null,
};

export type DeleteBillingEventLogInput = {
  id: string,
};

export type CreateMessageRecipientInput = {
  id?: string | null,
  recipientId: string,
  messageId: string,
};

export type ModelMessageRecipientConditionInput = {
  recipientId?: ModelIDInput | null,
  messageId?: ModelIDInput | null,
  and?: Array< ModelMessageRecipientConditionInput | null > | null,
  or?: Array< ModelMessageRecipientConditionInput | null > | null,
  not?: ModelMessageRecipientConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateMessageRecipientInput = {
  id: string,
  recipientId?: string | null,
  messageId?: string | null,
};

export type DeleteMessageRecipientInput = {
  id: string,
};

export type CreateMessageAttachmentInput = {
  id?: string | null,
  messageId: string,
  attachmentId: string,
};

export type ModelMessageAttachmentConditionInput = {
  messageId?: ModelIDInput | null,
  attachmentId?: ModelIDInput | null,
  and?: Array< ModelMessageAttachmentConditionInput | null > | null,
  or?: Array< ModelMessageAttachmentConditionInput | null > | null,
  not?: ModelMessageAttachmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateMessageAttachmentInput = {
  id: string,
  messageId?: string | null,
  attachmentId?: string | null,
};

export type DeleteMessageAttachmentInput = {
  id: string,
};

export type CreateMessageWithBodyInput = {
  id?: string | null,
  title?: string | null,
  body: string,
  bodySnippet?: string | null,
  status?: string | null,
  scheduledDate?: string | null,
  endOfLifeTrigger?: boolean | null,
  size?: number | null,
  userprofileID: string,
  sentDate?: string | null,
  recipientIds?: Array< string > | null,
  attachmentIds?: Array< string > | null,
};

export type UpdateMessageWithBodyInput = {
  id: string,
  title?: string | null,
  body: string,
  bodySnippet?: string | null,
  status?: string | null,
  scheduledDate?: string | null,
  endOfLifeTrigger?: boolean | null,
  size?: number | null,
  userprofileID?: string | null,
  sentDate?: string | null,
  recipientIds?: Array< string > | null,
  attachmentIds?: Array< string > | null,
};

export type CreateAttachmentWithPlatformGuardsInput = {
  name?: string | null,
  description?: string | null,
  s3Key: string,
};

export type UpdateAttachmentWithPlatformGuardsInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  s3Key?: string | null,
};

export type DeliveredAttachmentDownloadPayload = {
  __typename: "DeliveredAttachmentDownloadPayload",
  items:  Array<DeliveredAttachmentDownloadItem >,
  failures:  Array<DeliveredAttachmentDownloadFailure >,
  hasPartialFailure: boolean,
  message?: string | null,
};

export type DeliveredAttachmentDownloadItem = {
  __typename: "DeliveredAttachmentDownloadItem",
  id: string,
  fileName: string,
  fileType?: string | null,
  downloadUrl: string,
};

export type DeliveredAttachmentDownloadFailure = {
  __typename: "DeliveredAttachmentDownloadFailure",
  id: string,
  fileName?: string | null,
  reasonCode: string,
  reasonMessage?: string | null,
};

export type DeliveredAttachmentClaimPayload = {
  __typename: "DeliveredAttachmentClaimPayload",
  status: string,
  attachmentsCopiedAt?: string | null,
  retryAfterSeconds?: number | null,
  failures:  Array<DeliveredAttachmentDownloadFailure >,
};

export type ModelDeliveredMessagesFilterInput = {
  id?: ModelIDInput | null,
  recipientEmail?: ModelStringInput | null,
  recipientId?: ModelIDInput | null,
  recipientUserId?: ModelIDInput | null,
  deliveredAt?: ModelStringInput | null,
  deliveryType?: ModelStringInput | null,
  messageRead?: ModelBooleanInput | null,
  readReminderCount?: ModelIntInput | null,
  readReminderStatus?: ModelStringInput | null,
  status?: ModelStringInput | null,
  failureReason?: ModelStringInput | null,
  attemptCount?: ModelIntInput | null,
  lastAttemptAt?: ModelStringInput | null,
  statusUpdatedAt?: ModelStringInput | null,
  fromUserProfileId?: ModelIDInput | null,
  fromName?: ModelStringInput | null,
  fromEmail?: ModelStringInput | null,
  originalMessageId?: ModelIDInput | null,
  title?: ModelStringInput | null,
  body?: ModelStringInput | null,
  bodyIv?: ModelStringInput | null,
  bodyAuthTag?: ModelStringInput | null,
  bodyEncryptedDataKey?: ModelStringInput | null,
  bodySnippet?: ModelStringInput | null,
  hasAttachment?: ModelBooleanInput | null,
  attachmentCount?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDeliveredMessagesFilterInput | null > | null,
  or?: Array< ModelDeliveredMessagesFilterInput | null > | null,
  not?: ModelDeliveredMessagesFilterInput | null,
};

export type ModelDeliveredMessagesConnection = {
  __typename: "ModelDeliveredMessagesConnection",
  items:  Array<DeliveredMessages | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelDeliveredMessagesAttachmentsFilterInput = {
  id?: ModelIDInput | null,
  deliveredMessageId?: ModelIDInput | null,
  recipientEmail?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  fileSize?: ModelIntInput | null,
  s3Key?: ModelStringInput | null,
  uploadedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDeliveredMessagesAttachmentsFilterInput | null > | null,
  or?: Array< ModelDeliveredMessagesAttachmentsFilterInput | null > | null,
  not?: ModelDeliveredMessagesAttachmentsFilterInput | null,
};

export type ModelDeliveredMessagesAttachmentsConnection = {
  __typename: "ModelDeliveredMessagesAttachmentsConnection",
  items:  Array<DeliveredMessagesAttachments | null >,
  nextToken?: string | null,
};

export type ModelMessageDeliveryLogFilterInput = {
  id?: ModelIDInput | null,
  executionId?: ModelStringInput | null,
  actionType?: ModelStringInput | null,
  entityType?: ModelStringInput | null,
  entityId?: ModelIDInput | null,
  originalMessageId?: ModelIDInput | null,
  deliveredMessageId?: ModelIDInput | null,
  recipientId?: ModelIDInput | null,
  previousStatus?: ModelStringInput | null,
  newStatus?: ModelStringInput | null,
  attemptNumber?: ModelIntInput | null,
  errorSummary?: ModelStringInput | null,
  changedFields?: ModelStringInput | null,
  timestamp?: ModelStringInput | null,
  functionName?: ModelStringInput | null,
  details?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMessageDeliveryLogFilterInput | null > | null,
  or?: Array< ModelMessageDeliveryLogFilterInput | null > | null,
  not?: ModelMessageDeliveryLogFilterInput | null,
};

export type ModelMessageDeliveryLogConnection = {
  __typename: "ModelMessageDeliveryLogConnection",
  items:  Array<MessageDeliveryLog | null >,
  nextToken?: string | null,
};

export type ModelTestimonialsFilterInput = {
  id?: ModelIDInput | null,
  Name?: ModelStringInput | null,
  Location?: ModelStringInput | null,
  Comment?: ModelStringInput | null,
  Active?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelTestimonialsFilterInput | null > | null,
  or?: Array< ModelTestimonialsFilterInput | null > | null,
  not?: ModelTestimonialsFilterInput | null,
};

export type ModelTestimonialsConnection = {
  __typename: "ModelTestimonialsConnection",
  items:  Array<Testimonials | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  cognitoSub?: ModelStringInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  billingProviderId?: ModelIDInput | null,
  userPlanId?: ModelIDInput | null,
  pendingPlanId?: ModelIDInput | null,
  scheduledPlanId?: ModelIDInput | null,
  planStatus?: ModelStringInput | null,
  planSelectedAt?: ModelStringInput | null,
  planActivatedAt?: ModelStringInput | null,
  checkoutSessionRef?: ModelStringInput | null,
  checkoutMode?: ModelStringInput | null,
  pendingPaymentAmount?: ModelFloatInput | null,
  pendingPaymentQuotedAt?: ModelStringInput | null,
  latestPaymentId?: ModelStringInput | null,
  currentPeriodEnd?: ModelStringInput | null,
  billingProvider?: ModelStringInput | null,
  billingCustomerRef?: ModelStringInput | null,
  subscriptionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelUserProfileFilterInput = {
  id?: ModelIDInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  preferredName?: ModelStringInput | null,
  dateOfBirth?: ModelStringInput | null,
  primaryPhone?: ModelStringInput | null,
  primaryPhoneType?: ModelStringInput | null,
  secondaryPhone?: ModelStringInput | null,
  secondaryPhoneType?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  isAlive?: ModelBooleanInput | null,
  eolVerificationCount?: ModelIntInput | null,
  lastEolVerificationResponseAt?: ModelStringInput | null,
  lastEolVerificationSentAt?: ModelStringInput | null,
  eolVerificationStatus?: ModelEolVerificationStatusInput | null,
  currentEolVerificationCycleStartedAt?: ModelStringInput | null,
  lastEolVerificationMethod?: ModelEolVerificationMethodInput | null,
  lastSuccessfulLoginAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserProfileFilterInput | null > | null,
  or?: Array< ModelUserProfileFilterInput | null > | null,
  not?: ModelUserProfileFilterInput | null,
};

export type ModelUserProfileConnection = {
  __typename: "ModelUserProfileConnection",
  items:  Array<UserProfile | null >,
  nextToken?: string | null,
};

export type ModelUserPreferencesFilterInput = {
  id?: ModelIDInput | null,
  eolVerificationIntervalDays?: ModelIntInput | null,
  eolVerificationReminderCount?: ModelIntInput | null,
  eolVerificationReminderIntervalDays?: ModelIntInput | null,
  eolVerificationChannelEmailEnabled?: ModelBooleanInput | null,
  eolVerificationChannelSmsEnabled?: ModelBooleanInput | null,
  eolStopScheduledMessages?: ModelBooleanInput | null,
  minBodyWordCount?: ModelIntInput | null,
  eolAccountReaderRecipientId?: ModelIDInput | null,
  preferredLanguage?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserPreferencesFilterInput | null > | null,
  or?: Array< ModelUserPreferencesFilterInput | null > | null,
  not?: ModelUserPreferencesFilterInput | null,
};

export type ModelUserPreferencesConnection = {
  __typename: "ModelUserPreferencesConnection",
  items:  Array<UserPreferences | null >,
  nextToken?: string | null,
};

export type PlatformLimits = {
  __typename: "PlatformLimits",
  id: string,
  maxRecipientsPerMessage?: number | null,
  maxAttachmentsPerMessage?: number | null,
  maxGeneralFileSizeBytes?: number | null,
  maxVideoFileSizeBytes?: number | null,
  maxStorageBytesPerUser?: number | null,
  maxTotalAttachmentSizePerMessage?: number | null,
  allowedExtensions?: Array< string | null > | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelPlatformLimitsFilterInput = {
  id?: ModelIDInput | null,
  maxRecipientsPerMessage?: ModelIntInput | null,
  maxAttachmentsPerMessage?: ModelIntInput | null,
  maxGeneralFileSizeBytes?: ModelFloatInput | null,
  maxVideoFileSizeBytes?: ModelFloatInput | null,
  maxStorageBytesPerUser?: ModelFloatInput | null,
  maxTotalAttachmentSizePerMessage?: ModelFloatInput | null,
  allowedExtensions?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlatformLimitsFilterInput | null > | null,
  or?: Array< ModelPlatformLimitsFilterInput | null > | null,
  not?: ModelPlatformLimitsFilterInput | null,
};

export type ModelPlatformLimitsConnection = {
  __typename: "ModelPlatformLimitsConnection",
  items:  Array<PlatformLimits | null >,
  nextToken?: string | null,
};

export type UserPlatformLimits = {
  __typename: "UserPlatformLimits",
  id: string,
  platformLimitOverrides?: string | null,
  storageUsedBytes?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelUserPlatformLimitsFilterInput = {
  id?: ModelIDInput | null,
  platformLimitOverrides?: ModelStringInput | null,
  storageUsedBytes?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserPlatformLimitsFilterInput | null > | null,
  or?: Array< ModelUserPlatformLimitsFilterInput | null > | null,
  not?: ModelUserPlatformLimitsFilterInput | null,
};

export type ModelUserPlatformLimitsConnection = {
  __typename: "ModelUserPlatformLimitsConnection",
  items:  Array<UserPlatformLimits | null >,
  nextToken?: string | null,
};

export type ModelEolVerificationTokenFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  cycleId?: ModelStringInput | null,
  tokenHash?: ModelStringInput | null,
  status?: ModelEolVerificationTokenStatusInput | null,
  issuedAt?: ModelStringInput | null,
  expiresAt?: ModelStringInput | null,
  usedAt?: ModelStringInput | null,
  channel?: ModelEolVerificationChannelInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEolVerificationTokenFilterInput | null > | null,
  or?: Array< ModelEolVerificationTokenFilterInput | null > | null,
  not?: ModelEolVerificationTokenFilterInput | null,
};

export type ModelEolVerificationTokenConnection = {
  __typename: "ModelEolVerificationTokenConnection",
  items:  Array<EolVerificationToken | null >,
  nextToken?: string | null,
};

export type ModelPlanFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  type?: ModelStringInput | null,
  price?: ModelFloatInput | null,
  billingCycle?: ModelStringInput | null,
  status?: ModelStringInput | null,
  messagesAllowed?: ModelIntInput | null,
  attachmentsAllowed?: ModelIntInput | null,
  recipientsAllowed?: ModelIntInput | null,
  billingProviderId?: ModelIDInput | null,
  checkoutMode?: ModelStringInput | null,
  priceId?: ModelStringInput | null,
  billingConfig?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPlanFilterInput | null > | null,
  or?: Array< ModelPlanFilterInput | null > | null,
  not?: ModelPlanFilterInput | null,
};

export type ModelPlanConnection = {
  __typename: "ModelPlanConnection",
  items:  Array<Plan | null >,
  nextToken?: string | null,
};

export type ModelBillingProviderFilterInput = {
  id?: ModelIDInput | null,
  billingProviderId?: ModelStringInput | null,
  billingProviderName?: ModelStringInput | null,
  providerCode?: ModelStringInput | null,
  isActive?: ModelBooleanInput | null,
  checkoutMode?: ModelStringInput | null,
  webhookEnabled?: ModelBooleanInput | null,
  apiBaseUrl?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBillingProviderFilterInput | null > | null,
  or?: Array< ModelBillingProviderFilterInput | null > | null,
  not?: ModelBillingProviderFilterInput | null,
};

export type ModelBillingProviderConnection = {
  __typename: "ModelBillingProviderConnection",
  items:  Array<BillingProvider | null >,
  nextToken?: string | null,
};

export type ModelChangeLogFilterInput = {
  id?: ModelIDInput | null,
  requestId?: ModelStringInput | null,
  changedById?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  entityType?: ModelChangeLogEntityTypeInput | null,
  entityId?: ModelIDInput | null,
  changeType?: ModelChangeLogChangeTypeInput | null,
  fieldName?: ModelStringInput | null,
  oldValue?: ModelStringInput | null,
  newValue?: ModelStringInput | null,
  metadata?: ModelStringInput | null,
  dateTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelChangeLogFilterInput | null > | null,
  or?: Array< ModelChangeLogFilterInput | null > | null,
  not?: ModelChangeLogFilterInput | null,
};

export type ModelLegalAcceptanceFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  acceptedAt?: ModelStringInput | null,
  sessionId?: ModelStringInput | null,
  sourceApp?: ModelStringInput | null,
  clientType?: ModelLoginClientTypeInput | null,
  browser?: ModelStringInput | null,
  os?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLegalAcceptanceFilterInput | null > | null,
  or?: Array< ModelLegalAcceptanceFilterInput | null > | null,
  not?: ModelLegalAcceptanceFilterInput | null,
};

export type ModelLegalAcceptanceConnection = {
  __typename: "ModelLegalAcceptanceConnection",
  items:  Array<LegalAcceptance | null >,
  nextToken?: string | null,
};

export type ModelLoginEventFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  eventType?: ModelLoginEventTypeInput | null,
  occurredAt?: ModelStringInput | null,
  sessionId?: ModelStringInput | null,
  sourceApp?: ModelStringInput | null,
  clientType?: ModelLoginClientTypeInput | null,
  browser?: ModelStringInput | null,
  os?: ModelStringInput | null,
  userAgent?: ModelStringInput | null,
  authMethod?: ModelStringInput | null,
  mfaUsed?: ModelBooleanInput | null,
  ipHash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLoginEventFilterInput | null > | null,
  or?: Array< ModelLoginEventFilterInput | null > | null,
  not?: ModelLoginEventFilterInput | null,
};

export type ModelLoginEventConnection = {
  __typename: "ModelLoginEventConnection",
  items:  Array<LoginEvent | null >,
  nextToken?: string | null,
};

export type ModelBillingEventLogFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  provider?: ModelStringInput | null,
  providerEventId?: ModelStringInput | null,
  providerCustomerRef?: ModelStringInput | null,
  providerResourceRef?: ModelStringInput | null,
  eventType?: ModelStringInput | null,
  status?: ModelStringInput | null,
  planId?: ModelIDInput | null,
  amount?: ModelFloatInput | null,
  currency?: ModelStringInput | null,
  occurredAt?: ModelStringInput | null,
  receivedAt?: ModelStringInput | null,
  processedAt?: ModelStringInput | null,
  message?: ModelStringInput | null,
  rawPayload?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelBillingEventLogFilterInput | null > | null,
  or?: Array< ModelBillingEventLogFilterInput | null > | null,
  not?: ModelBillingEventLogFilterInput | null,
};

export type ModelBillingEventLogConnection = {
  __typename: "ModelBillingEventLogConnection",
  items:  Array<BillingEventLog | null >,
  nextToken?: string | null,
};

export type ModelMessageRecipientFilterInput = {
  id?: ModelIDInput | null,
  recipientId?: ModelIDInput | null,
  messageId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMessageRecipientFilterInput | null > | null,
  or?: Array< ModelMessageRecipientFilterInput | null > | null,
  not?: ModelMessageRecipientFilterInput | null,
};

export type ModelMessageAttachmentFilterInput = {
  id?: ModelIDInput | null,
  messageId?: ModelIDInput | null,
  attachmentId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMessageAttachmentFilterInput | null > | null,
  or?: Array< ModelMessageAttachmentFilterInput | null > | null,
  not?: ModelMessageAttachmentFilterInput | null,
};

export type EffectivePlatformLimits = {
  __typename: "EffectivePlatformLimits",
  maxRecipientsPerMessage?: number | null,
  maxAttachmentsPerMessage?: number | null,
  maxGeneralFileSizeBytes?: number | null,
  maxVideoFileSizeBytes?: number | null,
  maxStorageBytesPerUser?: number | null,
  maxTotalAttachmentSizePerMessage?: number | null,
  allowedExtensions?: Array< string | null > | null,
  storageUsedBytes?: number | null,
};

export type ModelSubscriptionDeliveredMessagesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  recipientId?: ModelSubscriptionIDInput | null,
  recipientUserId?: ModelSubscriptionIDInput | null,
  deliveredAt?: ModelSubscriptionStringInput | null,
  deliveryType?: ModelSubscriptionStringInput | null,
  messageRead?: ModelSubscriptionBooleanInput | null,
  readReminderCount?: ModelSubscriptionIntInput | null,
  readReminderStatus?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  failureReason?: ModelSubscriptionStringInput | null,
  attemptCount?: ModelSubscriptionIntInput | null,
  lastAttemptAt?: ModelSubscriptionStringInput | null,
  statusUpdatedAt?: ModelSubscriptionStringInput | null,
  fromUserProfileId?: ModelSubscriptionIDInput | null,
  fromName?: ModelSubscriptionStringInput | null,
  fromEmail?: ModelSubscriptionStringInput | null,
  originalMessageId?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  bodyIv?: ModelSubscriptionStringInput | null,
  bodyAuthTag?: ModelSubscriptionStringInput | null,
  bodyEncryptedDataKey?: ModelSubscriptionStringInput | null,
  bodySnippet?: ModelSubscriptionStringInput | null,
  hasAttachment?: ModelSubscriptionBooleanInput | null,
  attachmentCount?: ModelSubscriptionIntInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDeliveredMessagesFilterInput | null > | null,
  or?: Array< ModelSubscriptionDeliveredMessagesFilterInput | null > | null,
  recipientEmail?: ModelStringInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionDeliveredMessagesAttachmentsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  deliveredMessageId?: ModelSubscriptionIDInput | null,
  fileName?: ModelSubscriptionStringInput | null,
  fileType?: ModelSubscriptionStringInput | null,
  fileSize?: ModelSubscriptionIntInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  uploadedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionDeliveredMessagesAttachmentsFilterInput | null > | null,
  or?: Array< ModelSubscriptionDeliveredMessagesAttachmentsFilterInput | null > | null,
  recipientEmail?: ModelStringInput | null,
};

export type ModelSubscriptionMessageDeliveryLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  executionId?: ModelSubscriptionStringInput | null,
  actionType?: ModelSubscriptionStringInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  originalMessageId?: ModelSubscriptionIDInput | null,
  deliveredMessageId?: ModelSubscriptionIDInput | null,
  recipientId?: ModelSubscriptionIDInput | null,
  previousStatus?: ModelSubscriptionStringInput | null,
  newStatus?: ModelSubscriptionStringInput | null,
  attemptNumber?: ModelSubscriptionIntInput | null,
  errorSummary?: ModelSubscriptionStringInput | null,
  changedFields?: ModelSubscriptionStringInput | null,
  timestamp?: ModelSubscriptionStringInput | null,
  functionName?: ModelSubscriptionStringInput | null,
  details?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMessageDeliveryLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionMessageDeliveryLogFilterInput | null > | null,
};

export type ModelSubscriptionTestimonialsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  Name?: ModelSubscriptionStringInput | null,
  Location?: ModelSubscriptionStringInput | null,
  Comment?: ModelSubscriptionStringInput | null,
  Active?: ModelSubscriptionBooleanInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionTestimonialsFilterInput | null > | null,
  or?: Array< ModelSubscriptionTestimonialsFilterInput | null > | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  cognitoSub?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  billingProviderId?: ModelSubscriptionIDInput | null,
  userPlanId?: ModelSubscriptionIDInput | null,
  pendingPlanId?: ModelSubscriptionIDInput | null,
  scheduledPlanId?: ModelSubscriptionIDInput | null,
  planStatus?: ModelSubscriptionStringInput | null,
  planSelectedAt?: ModelSubscriptionStringInput | null,
  planActivatedAt?: ModelSubscriptionStringInput | null,
  checkoutSessionRef?: ModelSubscriptionStringInput | null,
  checkoutMode?: ModelSubscriptionStringInput | null,
  pendingPaymentAmount?: ModelSubscriptionFloatInput | null,
  pendingPaymentQuotedAt?: ModelSubscriptionStringInput | null,
  latestPaymentId?: ModelSubscriptionStringInput | null,
  currentPeriodEnd?: ModelSubscriptionStringInput | null,
  billingProvider?: ModelSubscriptionStringInput | null,
  billingCustomerRef?: ModelSubscriptionStringInput | null,
  subscriptionId?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionUserProfileFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  preferredName?: ModelSubscriptionStringInput | null,
  dateOfBirth?: ModelSubscriptionStringInput | null,
  primaryPhone?: ModelSubscriptionStringInput | null,
  primaryPhoneType?: ModelSubscriptionStringInput | null,
  secondaryPhone?: ModelSubscriptionStringInput | null,
  secondaryPhoneType?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  isAlive?: ModelSubscriptionBooleanInput | null,
  eolVerificationCount?: ModelSubscriptionIntInput | null,
  lastEolVerificationResponseAt?: ModelSubscriptionStringInput | null,
  lastEolVerificationSentAt?: ModelSubscriptionStringInput | null,
  eolVerificationStatus?: ModelSubscriptionStringInput | null,
  currentEolVerificationCycleStartedAt?: ModelSubscriptionStringInput | null,
  lastEolVerificationMethod?: ModelSubscriptionStringInput | null,
  lastSuccessfulLoginAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserProfileFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserProfileFilterInput | null > | null,
};

export type ModelSubscriptionUserPreferencesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  eolVerificationIntervalDays?: ModelSubscriptionIntInput | null,
  eolVerificationReminderCount?: ModelSubscriptionIntInput | null,
  eolVerificationReminderIntervalDays?: ModelSubscriptionIntInput | null,
  eolVerificationChannelEmailEnabled?: ModelSubscriptionBooleanInput | null,
  eolVerificationChannelSmsEnabled?: ModelSubscriptionBooleanInput | null,
  eolStopScheduledMessages?: ModelSubscriptionBooleanInput | null,
  minBodyWordCount?: ModelSubscriptionIntInput | null,
  eolAccountReaderRecipientId?: ModelSubscriptionIDInput | null,
  preferredLanguage?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserPreferencesFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserPreferencesFilterInput | null > | null,
};

export type ModelSubscriptionEolVerificationTokenFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  cycleId?: ModelSubscriptionStringInput | null,
  tokenHash?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  issuedAt?: ModelSubscriptionStringInput | null,
  expiresAt?: ModelSubscriptionStringInput | null,
  usedAt?: ModelSubscriptionStringInput | null,
  channel?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEolVerificationTokenFilterInput | null > | null,
  or?: Array< ModelSubscriptionEolVerificationTokenFilterInput | null > | null,
};

export type ModelSubscriptionRecipientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  phone?: ModelSubscriptionStringInput | null,
  phoneType?: ModelSubscriptionStringInput | null,
  sendSMS?: ModelSubscriptionBooleanInput | null,
  userprofileID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionRecipientFilterInput | null > | null,
  or?: Array< ModelSubscriptionRecipientFilterInput | null > | null,
};

export type ModelSubscriptionMessageFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  body?: ModelSubscriptionStringInput | null,
  bodyIv?: ModelSubscriptionStringInput | null,
  bodyAuthTag?: ModelSubscriptionStringInput | null,
  bodyEncryptedDataKey?: ModelSubscriptionStringInput | null,
  bodySnippet?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  scheduledDate?: ModelSubscriptionStringInput | null,
  endOfLifeTrigger?: ModelSubscriptionBooleanInput | null,
  size?: ModelSubscriptionFloatInput | null,
  userprofileID?: ModelSubscriptionIDInput | null,
  sentDate?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMessageFilterInput | null > | null,
  or?: Array< ModelSubscriptionMessageFilterInput | null > | null,
};

export type ModelSubscriptionPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  price?: ModelSubscriptionFloatInput | null,
  billingCycle?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  messagesAllowed?: ModelSubscriptionIntInput | null,
  attachmentsAllowed?: ModelSubscriptionIntInput | null,
  recipientsAllowed?: ModelSubscriptionIntInput | null,
  billingProviderId?: ModelSubscriptionIDInput | null,
  checkoutMode?: ModelSubscriptionStringInput | null,
  priceId?: ModelSubscriptionStringInput | null,
  billingConfig?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlanFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlanFilterInput | null > | null,
};

export type ModelSubscriptionBillingProviderFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  billingProviderId?: ModelSubscriptionStringInput | null,
  billingProviderName?: ModelSubscriptionStringInput | null,
  providerCode?: ModelSubscriptionStringInput | null,
  isActive?: ModelSubscriptionBooleanInput | null,
  checkoutMode?: ModelSubscriptionStringInput | null,
  webhookEnabled?: ModelSubscriptionBooleanInput | null,
  apiBaseUrl?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBillingProviderFilterInput | null > | null,
  or?: Array< ModelSubscriptionBillingProviderFilterInput | null > | null,
};

export type ModelSubscriptionAttachmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  size?: ModelSubscriptionFloatInput | null,
  s3Key?: ModelSubscriptionStringInput | null,
  uploadDate?: ModelSubscriptionStringInput | null,
  userprofileID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAttachmentFilterInput | null > | null,
};

export type ModelSubscriptionChangeLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  requestId?: ModelSubscriptionStringInput | null,
  changedById?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  entityType?: ModelSubscriptionStringInput | null,
  entityId?: ModelSubscriptionIDInput | null,
  changeType?: ModelSubscriptionStringInput | null,
  fieldName?: ModelSubscriptionStringInput | null,
  oldValue?: ModelSubscriptionStringInput | null,
  newValue?: ModelSubscriptionStringInput | null,
  metadata?: ModelSubscriptionStringInput | null,
  dateTime?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionChangeLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionChangeLogFilterInput | null > | null,
};

export type ModelSubscriptionLegalAcceptanceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  version?: ModelSubscriptionStringInput | null,
  acceptedAt?: ModelSubscriptionStringInput | null,
  sessionId?: ModelSubscriptionStringInput | null,
  sourceApp?: ModelSubscriptionStringInput | null,
  clientType?: ModelSubscriptionStringInput | null,
  browser?: ModelSubscriptionStringInput | null,
  os?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLegalAcceptanceFilterInput | null > | null,
  or?: Array< ModelSubscriptionLegalAcceptanceFilterInput | null > | null,
};

export type ModelSubscriptionLoginEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  eventType?: ModelSubscriptionStringInput | null,
  occurredAt?: ModelSubscriptionStringInput | null,
  sessionId?: ModelSubscriptionStringInput | null,
  sourceApp?: ModelSubscriptionStringInput | null,
  clientType?: ModelSubscriptionStringInput | null,
  browser?: ModelSubscriptionStringInput | null,
  os?: ModelSubscriptionStringInput | null,
  userAgent?: ModelSubscriptionStringInput | null,
  authMethod?: ModelSubscriptionStringInput | null,
  mfaUsed?: ModelSubscriptionBooleanInput | null,
  ipHash?: ModelSubscriptionStringInput | null,
  country?: ModelSubscriptionStringInput | null,
  region?: ModelSubscriptionStringInput | null,
  city?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionLoginEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionLoginEventFilterInput | null > | null,
};

export type ModelSubscriptionBillingEventLogFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  provider?: ModelSubscriptionStringInput | null,
  providerEventId?: ModelSubscriptionStringInput | null,
  providerCustomerRef?: ModelSubscriptionStringInput | null,
  providerResourceRef?: ModelSubscriptionStringInput | null,
  eventType?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  planId?: ModelSubscriptionIDInput | null,
  amount?: ModelSubscriptionFloatInput | null,
  currency?: ModelSubscriptionStringInput | null,
  occurredAt?: ModelSubscriptionStringInput | null,
  receivedAt?: ModelSubscriptionStringInput | null,
  processedAt?: ModelSubscriptionStringInput | null,
  message?: ModelSubscriptionStringInput | null,
  rawPayload?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionBillingEventLogFilterInput | null > | null,
  or?: Array< ModelSubscriptionBillingEventLogFilterInput | null > | null,
};

export type ModelSubscriptionMessageRecipientFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  recipientId?: ModelSubscriptionIDInput | null,
  messageId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMessageRecipientFilterInput | null > | null,
  or?: Array< ModelSubscriptionMessageRecipientFilterInput | null > | null,
};

export type ModelSubscriptionMessageAttachmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  messageId?: ModelSubscriptionIDInput | null,
  attachmentId?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMessageAttachmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionMessageAttachmentFilterInput | null > | null,
};

export type ListMessagesWithRecipientsQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessagesWithRecipientsQuery = {
  listMessages?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      id: string,
      title?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      createdAt: string,
      updatedAt: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        items:  Array< {
          __typename: "MessageRecipient",
          id: string,
          recipientId: string,
          recipient:  {
            __typename: "Recipient",
            id: string,
            firstName?: string | null,
            lastName?: string | null,
            email?: string | null,
            phone?: string | null,
            phoneType?: string | null,
            sendSMS?: boolean | null,
            userprofileID: string,
          },
        } | null >,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        items:  Array< {
          __typename: "MessageAttachment",
          id: string,
          attachment:  {
            __typename: "Attachment",
            id: string,
            name?: string | null,
            description?: string | null,
            type?: string | null,
            status?: string | null,
            size?: number | null,
            s3Key?: string | null,
            uploadDate?: string | null,
            userprofileID: string,
          },
        } | null >,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageByIdWithBodyHydratedQueryVariables = {
  id: string,
};

export type GetMessageByIdWithBodyHydratedQuery = {
  getMessageByIdWithBody?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
        recipient:  {
          __typename: "Recipient",
          id: string,
          firstName?: string | null,
          lastName?: string | null,
          email?: string | null,
          phone?: string | null,
          phoneType?: string | null,
          sendSMS?: boolean | null,
          userprofileID: string,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
        attachment:  {
          __typename: "Attachment",
          id: string,
          name?: string | null,
          description?: string | null,
          type?: string | null,
          status?: string | null,
          size?: number | null,
          s3Key?: string | null,
          uploadDate?: string | null,
          userprofileID: string,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAttachmentsWithMessagesQueryVariables = {
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttachmentsWithMessagesQuery = {
  listAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        items:  Array< {
          __typename: "MessageAttachment",
          message:  {
            __typename: "Message",
            id: string,
            title?: string | null,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRecipientsWithMessagesQueryVariables = {
  filter?: ModelRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecipientsWithMessagesQuery = {
  listRecipients?:  {
    __typename: "ModelRecipientConnection",
    items:  Array< {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        items:  Array< {
          __typename: "MessageRecipient",
          message:  {
            __typename: "Message",
            id: string,
            title?: string | null,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CreateUserMinimalMutationVariables = {
  input: CreateUserInput,
};

export type CreateUserMinimalMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    status?: string | null,
    billingProviderId?: string | null,
    planStatus?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    userPlanId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserPreferencesDocumentMutationVariables = {
  input: CreateUserPreferencesInput,
};

export type CreateUserPreferencesDocumentMutation = {
  createUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserPreferencesDocumentMutationVariables = {
  input: UpdateUserPreferencesInput,
};

export type UpdateUserPreferencesDocumentMutation = {
  updateUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ConfirmEolVerificationDocumentMutationVariables = {
  token: string,
};

export type ConfirmEolVerificationDocumentMutation = {
  confirmEolVerification:  {
    __typename: "EolVerificationConfirmResult",
    outcome: EolVerificationConfirmOutcome,
  },
};

export type CreateDeliveredMessagesMutationVariables = {
  input: CreateDeliveredMessagesInput,
  condition?: ModelDeliveredMessagesConditionInput | null,
};

export type CreateDeliveredMessagesMutation = {
  createDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDeliveredMessagesMutationVariables = {
  input: UpdateDeliveredMessagesInput,
  condition?: ModelDeliveredMessagesConditionInput | null,
};

export type UpdateDeliveredMessagesMutation = {
  updateDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDeliveredMessagesMutationVariables = {
  input: DeleteDeliveredMessagesInput,
  condition?: ModelDeliveredMessagesConditionInput | null,
};

export type DeleteDeliveredMessagesMutation = {
  deleteDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateDeliveredMessagesAttachmentsMutationVariables = {
  input: CreateDeliveredMessagesAttachmentsInput,
  condition?: ModelDeliveredMessagesAttachmentsConditionInput | null,
};

export type CreateDeliveredMessagesAttachmentsMutation = {
  createDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDeliveredMessagesAttachmentsMutationVariables = {
  input: UpdateDeliveredMessagesAttachmentsInput,
  condition?: ModelDeliveredMessagesAttachmentsConditionInput | null,
};

export type UpdateDeliveredMessagesAttachmentsMutation = {
  updateDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDeliveredMessagesAttachmentsMutationVariables = {
  input: DeleteDeliveredMessagesAttachmentsInput,
  condition?: ModelDeliveredMessagesAttachmentsConditionInput | null,
};

export type DeleteDeliveredMessagesAttachmentsMutation = {
  deleteDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMessageDeliveryLogMutationVariables = {
  input: CreateMessageDeliveryLogInput,
  condition?: ModelMessageDeliveryLogConditionInput | null,
};

export type CreateMessageDeliveryLogMutation = {
  createMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMessageDeliveryLogMutationVariables = {
  input: UpdateMessageDeliveryLogInput,
  condition?: ModelMessageDeliveryLogConditionInput | null,
};

export type UpdateMessageDeliveryLogMutation = {
  updateMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMessageDeliveryLogMutationVariables = {
  input: DeleteMessageDeliveryLogInput,
  condition?: ModelMessageDeliveryLogConditionInput | null,
};

export type DeleteMessageDeliveryLogMutation = {
  deleteMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateTestimonialsMutationVariables = {
  input: CreateTestimonialsInput,
  condition?: ModelTestimonialsConditionInput | null,
};

export type CreateTestimonialsMutation = {
  createTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTestimonialsMutationVariables = {
  input: UpdateTestimonialsInput,
  condition?: ModelTestimonialsConditionInput | null,
};

export type UpdateTestimonialsMutation = {
  updateTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteTestimonialsMutationVariables = {
  input: DeleteTestimonialsInput,
  condition?: ModelTestimonialsConditionInput | null,
};

export type DeleteTestimonialsMutation = {
  deleteTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserProfileMutationVariables = {
  input: CreateUserProfileInput,
  condition?: ModelUserProfileConditionInput | null,
};

export type CreateUserProfileMutation = {
  createUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserProfileMutationVariables = {
  input: UpdateUserProfileInput,
  condition?: ModelUserProfileConditionInput | null,
};

export type UpdateUserProfileMutation = {
  updateUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserProfileMutationVariables = {
  input: DeleteUserProfileInput,
  condition?: ModelUserProfileConditionInput | null,
};

export type DeleteUserProfileMutation = {
  deleteUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserPreferencesMutationVariables = {
  input: CreateUserPreferencesInput,
  condition?: ModelUserPreferencesConditionInput | null,
};

export type CreateUserPreferencesMutation = {
  createUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserPreferencesMutationVariables = {
  input: UpdateUserPreferencesInput,
  condition?: ModelUserPreferencesConditionInput | null,
};

export type UpdateUserPreferencesMutation = {
  updateUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserPreferencesMutationVariables = {
  input: DeleteUserPreferencesInput,
  condition?: ModelUserPreferencesConditionInput | null,
};

export type DeleteUserPreferencesMutation = {
  deleteUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEolVerificationTokenMutationVariables = {
  input: CreateEolVerificationTokenInput,
  condition?: ModelEolVerificationTokenConditionInput | null,
};

export type CreateEolVerificationTokenMutation = {
  createEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEolVerificationTokenMutationVariables = {
  input: UpdateEolVerificationTokenInput,
  condition?: ModelEolVerificationTokenConditionInput | null,
};

export type UpdateEolVerificationTokenMutation = {
  updateEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEolVerificationTokenMutationVariables = {
  input: DeleteEolVerificationTokenInput,
  condition?: ModelEolVerificationTokenConditionInput | null,
};

export type DeleteEolVerificationTokenMutation = {
  deleteEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecipientMutationVariables = {
  input: CreateRecipientInput,
  condition?: ModelRecipientConditionInput | null,
};

export type CreateRecipientMutation = {
  createRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateRecipientMutationVariables = {
  input: UpdateRecipientInput,
  condition?: ModelRecipientConditionInput | null,
};

export type UpdateRecipientMutation = {
  updateRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecipientMutationVariables = {
  input: DeleteRecipientInput,
  condition?: ModelRecipientConditionInput | null,
};

export type DeleteRecipientMutation = {
  deleteRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateRecipientWithPlatformGuardsMutationVariables = {
  input: CreateRecipientWithPlatformGuardsInput,
};

export type CreateRecipientWithPlatformGuardsMutation = {
  createRecipientWithPlatformGuards?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteRecipientWithPlatformGuardsMutationVariables = {
  id: string,
};

export type DeleteRecipientWithPlatformGuardsMutation = {
  deleteRecipientWithPlatformGuards?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMessageMutationVariables = {
  input: CreateMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type CreateMessageMutation = {
  createMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMessageMutationVariables = {
  input: UpdateMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type UpdateMessageMutation = {
  updateMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMessageMutationVariables = {
  input: DeleteMessageInput,
  condition?: ModelMessageConditionInput | null,
};

export type DeleteMessageMutation = {
  deleteMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePlanMutationVariables = {
  input: CreatePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type CreatePlanMutation = {
  createPlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePlanMutationVariables = {
  input: UpdatePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type UpdatePlanMutation = {
  updatePlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePlanMutationVariables = {
  input: DeletePlanInput,
  condition?: ModelPlanConditionInput | null,
};

export type DeletePlanMutation = {
  deletePlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBillingProviderMutationVariables = {
  input: CreateBillingProviderInput,
  condition?: ModelBillingProviderConditionInput | null,
};

export type CreateBillingProviderMutation = {
  createBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBillingProviderMutationVariables = {
  input: UpdateBillingProviderInput,
  condition?: ModelBillingProviderConditionInput | null,
};

export type UpdateBillingProviderMutation = {
  updateBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBillingProviderMutationVariables = {
  input: DeleteBillingProviderInput,
  condition?: ModelBillingProviderConditionInput | null,
};

export type DeleteBillingProviderMutation = {
  deleteBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAttachmentMutationVariables = {
  input: CreateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type CreateAttachmentMutation = {
  createAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAttachmentMutationVariables = {
  input: UpdateAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type UpdateAttachmentMutation = {
  updateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAttachmentMutationVariables = {
  input: DeleteAttachmentInput,
  condition?: ModelAttachmentConditionInput | null,
};

export type DeleteAttachmentMutation = {
  deleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateChangeLogMutationVariables = {
  input: CreateChangeLogInput,
  condition?: ModelChangeLogConditionInput | null,
};

export type CreateChangeLogMutation = {
  createChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateChangeLogMutationVariables = {
  input: UpdateChangeLogInput,
  condition?: ModelChangeLogConditionInput | null,
};

export type UpdateChangeLogMutation = {
  updateChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteChangeLogMutationVariables = {
  input: DeleteChangeLogInput,
  condition?: ModelChangeLogConditionInput | null,
};

export type DeleteChangeLogMutation = {
  deleteChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLegalAcceptanceMutationVariables = {
  input: CreateLegalAcceptanceInput,
  condition?: ModelLegalAcceptanceConditionInput | null,
};

export type CreateLegalAcceptanceMutation = {
  createLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLegalAcceptanceMutationVariables = {
  input: UpdateLegalAcceptanceInput,
  condition?: ModelLegalAcceptanceConditionInput | null,
};

export type UpdateLegalAcceptanceMutation = {
  updateLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLegalAcceptanceMutationVariables = {
  input: DeleteLegalAcceptanceInput,
  condition?: ModelLegalAcceptanceConditionInput | null,
};

export type DeleteLegalAcceptanceMutation = {
  deleteLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLoginEventMutationVariables = {
  input: CreateLoginEventInput,
  condition?: ModelLoginEventConditionInput | null,
};

export type CreateLoginEventMutation = {
  createLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLoginEventMutationVariables = {
  input: UpdateLoginEventInput,
  condition?: ModelLoginEventConditionInput | null,
};

export type UpdateLoginEventMutation = {
  updateLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLoginEventMutationVariables = {
  input: DeleteLoginEventInput,
  condition?: ModelLoginEventConditionInput | null,
};

export type DeleteLoginEventMutation = {
  deleteLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateBillingEventLogMutationVariables = {
  input: CreateBillingEventLogInput,
  condition?: ModelBillingEventLogConditionInput | null,
};

export type CreateBillingEventLogMutation = {
  createBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateBillingEventLogMutationVariables = {
  input: UpdateBillingEventLogInput,
  condition?: ModelBillingEventLogConditionInput | null,
};

export type UpdateBillingEventLogMutation = {
  updateBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteBillingEventLogMutationVariables = {
  input: DeleteBillingEventLogInput,
  condition?: ModelBillingEventLogConditionInput | null,
};

export type DeleteBillingEventLogMutation = {
  deleteBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMessageRecipientMutationVariables = {
  input: CreateMessageRecipientInput,
  condition?: ModelMessageRecipientConditionInput | null,
};

export type CreateMessageRecipientMutation = {
  createMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMessageRecipientMutationVariables = {
  input: UpdateMessageRecipientInput,
  condition?: ModelMessageRecipientConditionInput | null,
};

export type UpdateMessageRecipientMutation = {
  updateMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMessageRecipientMutationVariables = {
  input: DeleteMessageRecipientInput,
  condition?: ModelMessageRecipientConditionInput | null,
};

export type DeleteMessageRecipientMutation = {
  deleteMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMessageAttachmentMutationVariables = {
  input: CreateMessageAttachmentInput,
  condition?: ModelMessageAttachmentConditionInput | null,
};

export type CreateMessageAttachmentMutation = {
  createMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMessageAttachmentMutationVariables = {
  input: UpdateMessageAttachmentInput,
  condition?: ModelMessageAttachmentConditionInput | null,
};

export type UpdateMessageAttachmentMutation = {
  updateMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMessageAttachmentMutationVariables = {
  input: DeleteMessageAttachmentInput,
  condition?: ModelMessageAttachmentConditionInput | null,
};

export type DeleteMessageAttachmentMutation = {
  deleteMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMessageWithBodyMutationVariables = {
  input: CreateMessageWithBodyInput,
};

export type CreateMessageWithBodyMutation = {
  createMessageWithBody?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMessageWithBodyMutationVariables = {
  input: UpdateMessageWithBodyInput,
};

export type UpdateMessageWithBodyMutation = {
  updateMessageWithBody?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAttachmentWithPlatformGuardsMutationVariables = {
  input: CreateAttachmentWithPlatformGuardsInput,
};

export type CreateAttachmentWithPlatformGuardsMutation = {
  createAttachmentWithPlatformGuards?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAttachmentWithPlatformGuardsMutationVariables = {
  input: UpdateAttachmentWithPlatformGuardsInput,
};

export type UpdateAttachmentWithPlatformGuardsMutation = {
  updateAttachmentWithPlatformGuards?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAttachmentWithPlatformGuardsMutationVariables = {
  id: string,
};

export type DeleteAttachmentWithPlatformGuardsMutation = {
  deleteAttachmentWithPlatformGuards?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DownloadDeliveredMessageAttachmentsMutationVariables = {
  deliveredMessageId: string,
  attachmentIds?: Array< string > | null,
};

export type DownloadDeliveredMessageAttachmentsMutation = {
  downloadDeliveredMessageAttachments:  {
    __typename: "DeliveredAttachmentDownloadPayload",
    items:  Array< {
      __typename: "DeliveredAttachmentDownloadItem",
      id: string,
      fileName: string,
      fileType?: string | null,
      downloadUrl: string,
    } >,
    failures:  Array< {
      __typename: "DeliveredAttachmentDownloadFailure",
      id: string,
      fileName?: string | null,
      reasonCode: string,
      reasonMessage?: string | null,
    } >,
    hasPartialFailure: boolean,
    message?: string | null,
  },
};

export type ClaimDeliveredMessageAttachmentsMutationVariables = {
  deliveredMessageId: string,
};

export type ClaimDeliveredMessageAttachmentsMutation = {
  claimDeliveredMessageAttachments:  {
    __typename: "DeliveredAttachmentClaimPayload",
    status: string,
    attachmentsCopiedAt?: string | null,
    retryAfterSeconds?: number | null,
    failures:  Array< {
      __typename: "DeliveredAttachmentDownloadFailure",
      id: string,
      fileName?: string | null,
      reasonCode: string,
      reasonMessage?: string | null,
    } >,
  },
};

export type ConfirmEolVerificationMutationVariables = {
  token: string,
};

export type ConfirmEolVerificationMutation = {
  confirmEolVerification:  {
    __typename: "EolVerificationConfirmResult",
    outcome: EolVerificationConfirmOutcome,
  },
};

export type GetDeliveredMessagesQueryVariables = {
  id: string,
};

export type GetDeliveredMessagesQuery = {
  getDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDeliveredMessagesQueryVariables = {
  filter?: ModelDeliveredMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDeliveredMessagesQuery = {
  listDeliveredMessages?:  {
    __typename: "ModelDeliveredMessagesConnection",
    items:  Array< {
      __typename: "DeliveredMessages",
      id: string,
      recipientEmail: string,
      recipientId?: string | null,
      recipientUserId?: string | null,
      deliveredAt?: string | null,
      deliveryType: string,
      messageRead?: boolean | null,
      readReminderCount?: number | null,
      readReminderStatus?: string | null,
      status: string,
      failureReason?: string | null,
      attemptCount?: number | null,
      lastAttemptAt?: string | null,
      statusUpdatedAt?: string | null,
      fromUserProfileId?: string | null,
      fromName: string,
      fromEmail?: string | null,
      originalMessageId?: string | null,
      title: string,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      hasAttachment: boolean,
      attachmentCount: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DeliveredMessagesByRecipientEmailQueryVariables = {
  recipientEmail: string,
  deliveredAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDeliveredMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DeliveredMessagesByRecipientEmailQuery = {
  deliveredMessagesByRecipientEmail?:  {
    __typename: "ModelDeliveredMessagesConnection",
    items:  Array< {
      __typename: "DeliveredMessages",
      id: string,
      recipientEmail: string,
      recipientId?: string | null,
      recipientUserId?: string | null,
      deliveredAt?: string | null,
      deliveryType: string,
      messageRead?: boolean | null,
      readReminderCount?: number | null,
      readReminderStatus?: string | null,
      status: string,
      failureReason?: string | null,
      attemptCount?: number | null,
      lastAttemptAt?: string | null,
      statusUpdatedAt?: string | null,
      fromUserProfileId?: string | null,
      fromName: string,
      fromEmail?: string | null,
      originalMessageId?: string | null,
      title: string,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      hasAttachment: boolean,
      attachmentCount: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DeliveredMessagesByStatusAndStatusUpdatedAtQueryVariables = {
  status: string,
  statusUpdatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDeliveredMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DeliveredMessagesByStatusAndStatusUpdatedAtQuery = {
  deliveredMessagesByStatusAndStatusUpdatedAt?:  {
    __typename: "ModelDeliveredMessagesConnection",
    items:  Array< {
      __typename: "DeliveredMessages",
      id: string,
      recipientEmail: string,
      recipientId?: string | null,
      recipientUserId?: string | null,
      deliveredAt?: string | null,
      deliveryType: string,
      messageRead?: boolean | null,
      readReminderCount?: number | null,
      readReminderStatus?: string | null,
      status: string,
      failureReason?: string | null,
      attemptCount?: number | null,
      lastAttemptAt?: string | null,
      statusUpdatedAt?: string | null,
      fromUserProfileId?: string | null,
      fromName: string,
      fromEmail?: string | null,
      originalMessageId?: string | null,
      title: string,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      hasAttachment: boolean,
      attachmentCount: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DeliveredMessagesByOriginalMessageIdQueryVariables = {
  originalMessageId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDeliveredMessagesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DeliveredMessagesByOriginalMessageIdQuery = {
  deliveredMessagesByOriginalMessageId?:  {
    __typename: "ModelDeliveredMessagesConnection",
    items:  Array< {
      __typename: "DeliveredMessages",
      id: string,
      recipientEmail: string,
      recipientId?: string | null,
      recipientUserId?: string | null,
      deliveredAt?: string | null,
      deliveryType: string,
      messageRead?: boolean | null,
      readReminderCount?: number | null,
      readReminderStatus?: string | null,
      status: string,
      failureReason?: string | null,
      attemptCount?: number | null,
      lastAttemptAt?: string | null,
      statusUpdatedAt?: string | null,
      fromUserProfileId?: string | null,
      fromName: string,
      fromEmail?: string | null,
      originalMessageId?: string | null,
      title: string,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      hasAttachment: boolean,
      attachmentCount: number,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDeliveredMessagesAttachmentsQueryVariables = {
  id: string,
};

export type GetDeliveredMessagesAttachmentsQuery = {
  getDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDeliveredMessagesAttachmentsQueryVariables = {
  filter?: ModelDeliveredMessagesAttachmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDeliveredMessagesAttachmentsQuery = {
  listDeliveredMessagesAttachments?:  {
    __typename: "ModelDeliveredMessagesAttachmentsConnection",
    items:  Array< {
      __typename: "DeliveredMessagesAttachments",
      id: string,
      deliveredMessageId: string,
      recipientEmail: string,
      fileName: string,
      fileType?: string | null,
      fileSize?: number | null,
      s3Key: string,
      uploadedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AttachmentsByDeliveredMessageIdQueryVariables = {
  deliveredMessageId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDeliveredMessagesAttachmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AttachmentsByDeliveredMessageIdQuery = {
  attachmentsByDeliveredMessageId?:  {
    __typename: "ModelDeliveredMessagesAttachmentsConnection",
    items:  Array< {
      __typename: "DeliveredMessagesAttachments",
      id: string,
      deliveredMessageId: string,
      recipientEmail: string,
      fileName: string,
      fileType?: string | null,
      fileSize?: number | null,
      s3Key: string,
      uploadedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type DeliveredMessageAttachmentsByRecipientEmailQueryVariables = {
  recipientEmail: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelDeliveredMessagesAttachmentsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type DeliveredMessageAttachmentsByRecipientEmailQuery = {
  deliveredMessageAttachmentsByRecipientEmail?:  {
    __typename: "ModelDeliveredMessagesAttachmentsConnection",
    items:  Array< {
      __typename: "DeliveredMessagesAttachments",
      id: string,
      deliveredMessageId: string,
      recipientEmail: string,
      fileName: string,
      fileType?: string | null,
      fileSize?: number | null,
      s3Key: string,
      uploadedAt?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageDeliveryLogQueryVariables = {
  id: string,
};

export type GetMessageDeliveryLogQuery = {
  getMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMessageDeliveryLogsQueryVariables = {
  filter?: ModelMessageDeliveryLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessageDeliveryLogsQuery = {
  listMessageDeliveryLogs?:  {
    __typename: "ModelMessageDeliveryLogConnection",
    items:  Array< {
      __typename: "MessageDeliveryLog",
      id: string,
      executionId: string,
      actionType: string,
      entityType: string,
      entityId: string,
      originalMessageId?: string | null,
      deliveredMessageId?: string | null,
      recipientId?: string | null,
      previousStatus?: string | null,
      newStatus?: string | null,
      attemptNumber?: number | null,
      errorSummary?: string | null,
      changedFields?: string | null,
      timestamp: string,
      functionName: string,
      details?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTestimonialsQueryVariables = {
  id: string,
};

export type GetTestimonialsQuery = {
  getTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTestimonialsQueryVariables = {
  filter?: ModelTestimonialsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTestimonialsQuery = {
  listTestimonials?:  {
    __typename: "ModelTestimonialsConnection",
    items:  Array< {
      __typename: "Testimonials",
      id: string,
      Name?: string | null,
      Location?: string | null,
      Comment?: string | null,
      Active?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      cognitoSub?: string | null,
      email: string,
      status?: string | null,
      UserProfile?:  {
        __typename: "UserProfile",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        preferredName?: string | null,
        dateOfBirth?: string | null,
        primaryPhone?: string | null,
        primaryPhoneType?: string | null,
        secondaryPhone?: string | null,
        secondaryPhoneType?: string | null,
        isActive?: boolean | null,
        isAlive?: boolean | null,
        eolVerificationCount?: number | null,
        lastEolVerificationResponseAt?: string | null,
        lastEolVerificationSentAt?: string | null,
        eolVerificationStatus?: EolVerificationStatus | null,
        currentEolVerificationCycleStartedAt?: string | null,
        lastEolVerificationMethod?: EolVerificationMethod | null,
        lastSuccessfulLoginAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      UserPreferences?:  {
        __typename: "UserPreferences",
        id: string,
        eolVerificationIntervalDays?: number | null,
        eolVerificationReminderCount?: number | null,
        eolVerificationReminderIntervalDays?: number | null,
        eolVerificationChannelEmailEnabled?: boolean | null,
        eolVerificationChannelSmsEnabled?: boolean | null,
        eolStopScheduledMessages?: boolean | null,
        minBodyWordCount?: number | null,
        eolAccountReaderRecipientId?: string | null,
        preferredLanguage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      billingProviderId?: string | null,
      userPlanId?: string | null,
      pendingPlanId?: string | null,
      scheduledPlanId?: string | null,
      planStatus?: string | null,
      planSelectedAt?: string | null,
      planActivatedAt?: string | null,
      checkoutSessionRef?: string | null,
      checkoutMode?: string | null,
      pendingPaymentAmount?: number | null,
      pendingPaymentQuotedAt?: string | null,
      latestPaymentId?: string | null,
      currentPeriodEnd?: string | null,
      billingProvider?: string | null,
      billingCustomerRef?: string | null,
      subscriptionId?: string | null,
      ChangeLogs?:  {
        __typename: "ModelChangeLogConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserByEmailQuery = {
  userByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      cognitoSub?: string | null,
      email: string,
      status?: string | null,
      UserProfile?:  {
        __typename: "UserProfile",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        preferredName?: string | null,
        dateOfBirth?: string | null,
        primaryPhone?: string | null,
        primaryPhoneType?: string | null,
        secondaryPhone?: string | null,
        secondaryPhoneType?: string | null,
        isActive?: boolean | null,
        isAlive?: boolean | null,
        eolVerificationCount?: number | null,
        lastEolVerificationResponseAt?: string | null,
        lastEolVerificationSentAt?: string | null,
        eolVerificationStatus?: EolVerificationStatus | null,
        currentEolVerificationCycleStartedAt?: string | null,
        lastEolVerificationMethod?: EolVerificationMethod | null,
        lastSuccessfulLoginAt?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      UserPreferences?:  {
        __typename: "UserPreferences",
        id: string,
        eolVerificationIntervalDays?: number | null,
        eolVerificationReminderCount?: number | null,
        eolVerificationReminderIntervalDays?: number | null,
        eolVerificationChannelEmailEnabled?: boolean | null,
        eolVerificationChannelSmsEnabled?: boolean | null,
        eolStopScheduledMessages?: boolean | null,
        minBodyWordCount?: number | null,
        eolAccountReaderRecipientId?: string | null,
        preferredLanguage?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      billingProviderId?: string | null,
      userPlanId?: string | null,
      pendingPlanId?: string | null,
      scheduledPlanId?: string | null,
      planStatus?: string | null,
      planSelectedAt?: string | null,
      planActivatedAt?: string | null,
      checkoutSessionRef?: string | null,
      checkoutMode?: string | null,
      pendingPaymentAmount?: number | null,
      pendingPaymentQuotedAt?: string | null,
      latestPaymentId?: string | null,
      currentPeriodEnd?: string | null,
      billingProvider?: string | null,
      billingCustomerRef?: string | null,
      subscriptionId?: string | null,
      ChangeLogs?:  {
        __typename: "ModelChangeLogConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserProfileQueryVariables = {
  id: string,
};

export type GetUserProfileQuery = {
  getUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserProfilesQueryVariables = {
  filter?: ModelUserProfileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserProfilesQuery = {
  listUserProfiles?:  {
    __typename: "ModelUserProfileConnection",
    items:  Array< {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserPreferencesQueryVariables = {
  id: string,
};

export type GetUserPreferencesQuery = {
  getUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserPreferencesQueryVariables = {
  filter?: ModelUserPreferencesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserPreferencesQuery = {
  listUserPreferences?:  {
    __typename: "ModelUserPreferencesConnection",
    items:  Array< {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlatformLimitsQueryVariables = {
  id: string,
};

export type GetPlatformLimitsQuery = {
  getPlatformLimits?:  {
    __typename: "PlatformLimits",
    id: string,
    maxRecipientsPerMessage?: number | null,
    maxAttachmentsPerMessage?: number | null,
    maxGeneralFileSizeBytes?: number | null,
    maxVideoFileSizeBytes?: number | null,
    maxStorageBytesPerUser?: number | null,
    maxTotalAttachmentSizePerMessage?: number | null,
    allowedExtensions?: Array< string | null > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPlatformLimitsQueryVariables = {
  filter?: ModelPlatformLimitsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlatformLimitsQuery = {
  listPlatformLimits?:  {
    __typename: "ModelPlatformLimitsConnection",
    items:  Array< {
      __typename: "PlatformLimits",
      id: string,
      maxRecipientsPerMessage?: number | null,
      maxAttachmentsPerMessage?: number | null,
      maxGeneralFileSizeBytes?: number | null,
      maxVideoFileSizeBytes?: number | null,
      maxStorageBytesPerUser?: number | null,
      maxTotalAttachmentSizePerMessage?: number | null,
      allowedExtensions?: Array< string | null > | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserPlatformLimitsQueryVariables = {
  id: string,
};

export type GetUserPlatformLimitsQuery = {
  getUserPlatformLimits?:  {
    __typename: "UserPlatformLimits",
    id: string,
    platformLimitOverrides?: string | null,
    storageUsedBytes?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserPlatformLimitsQueryVariables = {
  filter?: ModelUserPlatformLimitsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserPlatformLimitsQuery = {
  listUserPlatformLimits?:  {
    __typename: "ModelUserPlatformLimitsConnection",
    items:  Array< {
      __typename: "UserPlatformLimits",
      id: string,
      platformLimitOverrides?: string | null,
      storageUsedBytes?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEolVerificationTokenQueryVariables = {
  id: string,
};

export type GetEolVerificationTokenQuery = {
  getEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEolVerificationTokensQueryVariables = {
  filter?: ModelEolVerificationTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEolVerificationTokensQuery = {
  listEolVerificationTokens?:  {
    __typename: "ModelEolVerificationTokenConnection",
    items:  Array< {
      __typename: "EolVerificationToken",
      id: string,
      userId: string,
      cycleId: string,
      tokenHash: string,
      status: EolVerificationTokenStatus,
      issuedAt: string,
      expiresAt: string,
      usedAt?: string | null,
      channel: EolVerificationChannel,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EolVerificationTokensByUserQueryVariables = {
  userId: string,
  issuedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEolVerificationTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EolVerificationTokensByUserQuery = {
  eolVerificationTokensByUser?:  {
    __typename: "ModelEolVerificationTokenConnection",
    items:  Array< {
      __typename: "EolVerificationToken",
      id: string,
      userId: string,
      cycleId: string,
      tokenHash: string,
      status: EolVerificationTokenStatus,
      issuedAt: string,
      expiresAt: string,
      usedAt?: string | null,
      channel: EolVerificationChannel,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EolVerificationTokensByCycleQueryVariables = {
  cycleId: string,
  issuedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEolVerificationTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EolVerificationTokensByCycleQuery = {
  eolVerificationTokensByCycle?:  {
    __typename: "ModelEolVerificationTokenConnection",
    items:  Array< {
      __typename: "EolVerificationToken",
      id: string,
      userId: string,
      cycleId: string,
      tokenHash: string,
      status: EolVerificationTokenStatus,
      issuedAt: string,
      expiresAt: string,
      usedAt?: string | null,
      channel: EolVerificationChannel,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type EolVerificationTokenByTokenHashQueryVariables = {
  tokenHash: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEolVerificationTokenFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type EolVerificationTokenByTokenHashQuery = {
  eolVerificationTokenByTokenHash?:  {
    __typename: "ModelEolVerificationTokenConnection",
    items:  Array< {
      __typename: "EolVerificationToken",
      id: string,
      userId: string,
      cycleId: string,
      tokenHash: string,
      status: EolVerificationTokenStatus,
      issuedAt: string,
      expiresAt: string,
      usedAt?: string | null,
      channel: EolVerificationChannel,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRecipientQueryVariables = {
  id: string,
};

export type GetRecipientQuery = {
  getRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListRecipientsQueryVariables = {
  filter?: ModelRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRecipientsQuery = {
  listRecipients?:  {
    __typename: "ModelRecipientConnection",
    items:  Array< {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RecipientsByUserprofileIDQueryVariables = {
  userprofileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RecipientsByUserprofileIDQuery = {
  recipientsByUserprofileID?:  {
    __typename: "ModelRecipientConnection",
    items:  Array< {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageQueryVariables = {
  id: string,
};

export type GetMessageQuery = {
  getMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMessagesQueryVariables = {
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessagesQuery = {
  listMessages?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MessagesByUserprofileIDQueryVariables = {
  userprofileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMessageFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MessagesByUserprofileIDQuery = {
  messagesByUserprofileID?:  {
    __typename: "ModelMessageConnection",
    items:  Array< {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPlanQueryVariables = {
  id: string,
};

export type GetPlanQuery = {
  getPlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPlansQueryVariables = {
  filter?: ModelPlanFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlansQuery = {
  listPlans?:  {
    __typename: "ModelPlanConnection",
    items:  Array< {
      __typename: "Plan",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      price?: number | null,
      billingCycle?: string | null,
      status?: string | null,
      messagesAllowed?: number | null,
      attachmentsAllowed?: number | null,
      recipientsAllowed?: number | null,
      billingProviderId?: string | null,
      checkoutMode?: string | null,
      priceId?: string | null,
      billingConfig?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBillingProviderQueryVariables = {
  id: string,
};

export type GetBillingProviderQuery = {
  getBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBillingProvidersQueryVariables = {
  filter?: ModelBillingProviderFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBillingProvidersQuery = {
  listBillingProviders?:  {
    __typename: "ModelBillingProviderConnection",
    items:  Array< {
      __typename: "BillingProvider",
      id: string,
      billingProviderId?: string | null,
      billingProviderName?: string | null,
      providerCode?: string | null,
      isActive?: boolean | null,
      checkoutMode?: string | null,
      webhookEnabled?: boolean | null,
      apiBaseUrl?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAttachmentQueryVariables = {
  id: string,
};

export type GetAttachmentQuery = {
  getAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAttachmentsQueryVariables = {
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAttachmentsQuery = {
  listAttachments?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AttachmentsByUserprofileIDQueryVariables = {
  userprofileID: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AttachmentsByUserprofileIDQuery = {
  attachmentsByUserprofileID?:  {
    __typename: "ModelAttachmentConnection",
    items:  Array< {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetChangeLogQueryVariables = {
  id: string,
};

export type GetChangeLogQuery = {
  getChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListChangeLogsQueryVariables = {
  filter?: ModelChangeLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListChangeLogsQuery = {
  listChangeLogs?:  {
    __typename: "ModelChangeLogConnection",
    items:  Array< {
      __typename: "ChangeLog",
      id: string,
      requestId: string,
      changedById: string,
      userId: string,
      entityType: ChangeLogEntityType,
      entityId: string,
      changeType: ChangeLogChangeType,
      fieldName?: string | null,
      oldValue?: string | null,
      newValue?: string | null,
      metadata?: string | null,
      dateTime: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ChangeLogsByUserIdQueryVariables = {
  userId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelChangeLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ChangeLogsByUserIdQuery = {
  changeLogsByUserId?:  {
    __typename: "ModelChangeLogConnection",
    items:  Array< {
      __typename: "ChangeLog",
      id: string,
      requestId: string,
      changedById: string,
      userId: string,
      entityType: ChangeLogEntityType,
      entityId: string,
      changeType: ChangeLogChangeType,
      fieldName?: string | null,
      oldValue?: string | null,
      newValue?: string | null,
      metadata?: string | null,
      dateTime: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLegalAcceptanceQueryVariables = {
  id: string,
};

export type GetLegalAcceptanceQuery = {
  getLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLegalAcceptancesQueryVariables = {
  filter?: ModelLegalAcceptanceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLegalAcceptancesQuery = {
  listLegalAcceptances?:  {
    __typename: "ModelLegalAcceptanceConnection",
    items:  Array< {
      __typename: "LegalAcceptance",
      id: string,
      userId: string,
      version: string,
      acceptedAt: string,
      sessionId: string,
      sourceApp: string,
      clientType: LoginClientType,
      browser: string,
      os: string,
      userAgent: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LegalAcceptancesByUserQueryVariables = {
  userId: string,
  acceptedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLegalAcceptanceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LegalAcceptancesByUserQuery = {
  legalAcceptancesByUser?:  {
    __typename: "ModelLegalAcceptanceConnection",
    items:  Array< {
      __typename: "LegalAcceptance",
      id: string,
      userId: string,
      version: string,
      acceptedAt: string,
      sessionId: string,
      sourceApp: string,
      clientType: LoginClientType,
      browser: string,
      os: string,
      userAgent: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLoginEventQueryVariables = {
  id: string,
};

export type GetLoginEventQuery = {
  getLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLoginEventsQueryVariables = {
  filter?: ModelLoginEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLoginEventsQuery = {
  listLoginEvents?:  {
    __typename: "ModelLoginEventConnection",
    items:  Array< {
      __typename: "LoginEvent",
      id: string,
      userId: string,
      eventType: LoginEventType,
      occurredAt: string,
      sessionId: string,
      sourceApp: string,
      clientType: LoginClientType,
      browser: string,
      os: string,
      userAgent: string,
      authMethod: string,
      mfaUsed: boolean,
      ipHash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LoginEventsByUserQueryVariables = {
  userId: string,
  occurredAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLoginEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LoginEventsByUserQuery = {
  loginEventsByUser?:  {
    __typename: "ModelLoginEventConnection",
    items:  Array< {
      __typename: "LoginEvent",
      id: string,
      userId: string,
      eventType: LoginEventType,
      occurredAt: string,
      sessionId: string,
      sourceApp: string,
      clientType: LoginClientType,
      browser: string,
      os: string,
      userAgent: string,
      authMethod: string,
      mfaUsed: boolean,
      ipHash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type LoginEventsByEventTypeQueryVariables = {
  eventType: LoginEventType,
  occurredAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLoginEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type LoginEventsByEventTypeQuery = {
  loginEventsByEventType?:  {
    __typename: "ModelLoginEventConnection",
    items:  Array< {
      __typename: "LoginEvent",
      id: string,
      userId: string,
      eventType: LoginEventType,
      occurredAt: string,
      sessionId: string,
      sourceApp: string,
      clientType: LoginClientType,
      browser: string,
      os: string,
      userAgent: string,
      authMethod: string,
      mfaUsed: boolean,
      ipHash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetBillingEventLogQueryVariables = {
  id: string,
};

export type GetBillingEventLogQuery = {
  getBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListBillingEventLogsQueryVariables = {
  filter?: ModelBillingEventLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListBillingEventLogsQuery = {
  listBillingEventLogs?:  {
    __typename: "ModelBillingEventLogConnection",
    items:  Array< {
      __typename: "BillingEventLog",
      id: string,
      userId: string,
      provider: string,
      providerEventId: string,
      providerCustomerRef?: string | null,
      providerResourceRef?: string | null,
      eventType: string,
      status: string,
      planId?: string | null,
      amount?: number | null,
      currency?: string | null,
      occurredAt?: string | null,
      receivedAt: string,
      processedAt?: string | null,
      message?: string | null,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BillingEventLogsByUserQueryVariables = {
  userId: string,
  receivedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBillingEventLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BillingEventLogsByUserQuery = {
  billingEventLogsByUser?:  {
    __typename: "ModelBillingEventLogConnection",
    items:  Array< {
      __typename: "BillingEventLog",
      id: string,
      userId: string,
      provider: string,
      providerEventId: string,
      providerCustomerRef?: string | null,
      providerResourceRef?: string | null,
      eventType: string,
      status: string,
      planId?: string | null,
      amount?: number | null,
      currency?: string | null,
      occurredAt?: string | null,
      receivedAt: string,
      processedAt?: string | null,
      message?: string | null,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type BillingEventLogByProviderEventIdQueryVariables = {
  providerEventId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelBillingEventLogFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type BillingEventLogByProviderEventIdQuery = {
  billingEventLogByProviderEventId?:  {
    __typename: "ModelBillingEventLogConnection",
    items:  Array< {
      __typename: "BillingEventLog",
      id: string,
      userId: string,
      provider: string,
      providerEventId: string,
      providerCustomerRef?: string | null,
      providerResourceRef?: string | null,
      eventType: string,
      status: string,
      planId?: string | null,
      amount?: number | null,
      currency?: string | null,
      occurredAt?: string | null,
      receivedAt: string,
      processedAt?: string | null,
      message?: string | null,
      rawPayload?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageRecipientQueryVariables = {
  id: string,
};

export type GetMessageRecipientQuery = {
  getMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMessageRecipientsQueryVariables = {
  filter?: ModelMessageRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessageRecipientsQuery = {
  listMessageRecipients?:  {
    __typename: "ModelMessageRecipientConnection",
    items:  Array< {
      __typename: "MessageRecipient",
      id: string,
      recipientId: string,
      messageId: string,
      recipient:  {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MessageRecipientsByRecipientIdQueryVariables = {
  recipientId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMessageRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MessageRecipientsByRecipientIdQuery = {
  messageRecipientsByRecipientId?:  {
    __typename: "ModelMessageRecipientConnection",
    items:  Array< {
      __typename: "MessageRecipient",
      id: string,
      recipientId: string,
      messageId: string,
      recipient:  {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MessageRecipientsByMessageIdQueryVariables = {
  messageId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMessageRecipientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MessageRecipientsByMessageIdQuery = {
  messageRecipientsByMessageId?:  {
    __typename: "ModelMessageRecipientConnection",
    items:  Array< {
      __typename: "MessageRecipient",
      id: string,
      recipientId: string,
      messageId: string,
      recipient:  {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageAttachmentQueryVariables = {
  id: string,
};

export type GetMessageAttachmentQuery = {
  getMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMessageAttachmentsQueryVariables = {
  filter?: ModelMessageAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMessageAttachmentsQuery = {
  listMessageAttachments?:  {
    __typename: "ModelMessageAttachmentConnection",
    items:  Array< {
      __typename: "MessageAttachment",
      id: string,
      messageId: string,
      attachmentId: string,
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      attachment:  {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MessageAttachmentsByMessageIdQueryVariables = {
  messageId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMessageAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MessageAttachmentsByMessageIdQuery = {
  messageAttachmentsByMessageId?:  {
    __typename: "ModelMessageAttachmentConnection",
    items:  Array< {
      __typename: "MessageAttachment",
      id: string,
      messageId: string,
      attachmentId: string,
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      attachment:  {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type MessageAttachmentsByAttachmentIdQueryVariables = {
  attachmentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelMessageAttachmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type MessageAttachmentsByAttachmentIdQuery = {
  messageAttachmentsByAttachmentId?:  {
    __typename: "ModelMessageAttachmentConnection",
    items:  Array< {
      __typename: "MessageAttachment",
      id: string,
      messageId: string,
      attachmentId: string,
      message:  {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      attachment:  {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMessageByIdWithBodyQueryVariables = {
  id: string,
};

export type GetMessageByIdWithBodyQuery = {
  getMessageByIdWithBody?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetDeliveredMessageByIdWithBodyQueryVariables = {
  id: string,
};

export type GetDeliveredMessageByIdWithBodyQuery = {
  getDeliveredMessageByIdWithBody?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    attachmentsCopiedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetMyEffectivePlatformLimitsQueryVariables = {
};

export type GetMyEffectivePlatformLimitsQuery = {
  getMyEffectivePlatformLimits?:  {
    __typename: "EffectivePlatformLimits",
    maxRecipientsPerMessage?: number | null,
    maxAttachmentsPerMessage?: number | null,
    maxGeneralFileSizeBytes?: number | null,
    maxVideoFileSizeBytes?: number | null,
    maxStorageBytesPerUser?: number | null,
    maxTotalAttachmentSizePerMessage?: number | null,
    allowedExtensions?: Array< string | null > | null,
    storageUsedBytes?: number | null,
  } | null,
};

export type OnCreateDeliveredMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesFilterInput | null,
  recipientEmail?: string | null,
};

export type OnCreateDeliveredMessagesSubscription = {
  onCreateDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDeliveredMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesFilterInput | null,
  recipientEmail?: string | null,
};

export type OnUpdateDeliveredMessagesSubscription = {
  onUpdateDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDeliveredMessagesSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesFilterInput | null,
  recipientEmail?: string | null,
};

export type OnDeleteDeliveredMessagesSubscription = {
  onDeleteDeliveredMessages?:  {
    __typename: "DeliveredMessages",
    id: string,
    recipientEmail: string,
    recipientId?: string | null,
    recipientUserId?: string | null,
    deliveredAt?: string | null,
    deliveryType: string,
    messageRead?: boolean | null,
    readReminderCount?: number | null,
    readReminderStatus?: string | null,
    status: string,
    failureReason?: string | null,
    attemptCount?: number | null,
    lastAttemptAt?: string | null,
    statusUpdatedAt?: string | null,
    fromUserProfileId?: string | null,
    fromName: string,
    fromEmail?: string | null,
    originalMessageId?: string | null,
    title: string,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    hasAttachment: boolean,
    attachmentCount: number,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateDeliveredMessagesAttachmentsSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesAttachmentsFilterInput | null,
  recipientEmail?: string | null,
};

export type OnCreateDeliveredMessagesAttachmentsSubscription = {
  onCreateDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDeliveredMessagesAttachmentsSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesAttachmentsFilterInput | null,
  recipientEmail?: string | null,
};

export type OnUpdateDeliveredMessagesAttachmentsSubscription = {
  onUpdateDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDeliveredMessagesAttachmentsSubscriptionVariables = {
  filter?: ModelSubscriptionDeliveredMessagesAttachmentsFilterInput | null,
  recipientEmail?: string | null,
};

export type OnDeleteDeliveredMessagesAttachmentsSubscription = {
  onDeleteDeliveredMessagesAttachments?:  {
    __typename: "DeliveredMessagesAttachments",
    id: string,
    deliveredMessageId: string,
    recipientEmail: string,
    fileName: string,
    fileType?: string | null,
    fileSize?: number | null,
    s3Key: string,
    uploadedAt?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMessageDeliveryLogSubscriptionVariables = {
  filter?: ModelSubscriptionMessageDeliveryLogFilterInput | null,
};

export type OnCreateMessageDeliveryLogSubscription = {
  onCreateMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMessageDeliveryLogSubscriptionVariables = {
  filter?: ModelSubscriptionMessageDeliveryLogFilterInput | null,
};

export type OnUpdateMessageDeliveryLogSubscription = {
  onUpdateMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMessageDeliveryLogSubscriptionVariables = {
  filter?: ModelSubscriptionMessageDeliveryLogFilterInput | null,
};

export type OnDeleteMessageDeliveryLogSubscription = {
  onDeleteMessageDeliveryLog?:  {
    __typename: "MessageDeliveryLog",
    id: string,
    executionId: string,
    actionType: string,
    entityType: string,
    entityId: string,
    originalMessageId?: string | null,
    deliveredMessageId?: string | null,
    recipientId?: string | null,
    previousStatus?: string | null,
    newStatus?: string | null,
    attemptNumber?: number | null,
    errorSummary?: string | null,
    changedFields?: string | null,
    timestamp: string,
    functionName: string,
    details?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateTestimonialsSubscriptionVariables = {
  filter?: ModelSubscriptionTestimonialsFilterInput | null,
};

export type OnCreateTestimonialsSubscription = {
  onCreateTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateTestimonialsSubscriptionVariables = {
  filter?: ModelSubscriptionTestimonialsFilterInput | null,
};

export type OnUpdateTestimonialsSubscription = {
  onUpdateTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteTestimonialsSubscriptionVariables = {
  filter?: ModelSubscriptionTestimonialsFilterInput | null,
};

export type OnDeleteTestimonialsSubscription = {
  onDeleteTestimonials?:  {
    __typename: "Testimonials",
    id: string,
    Name?: string | null,
    Location?: string | null,
    Comment?: string | null,
    Active?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    cognitoSub?: string | null,
    email: string,
    status?: string | null,
    UserProfile?:  {
      __typename: "UserProfile",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      preferredName?: string | null,
      dateOfBirth?: string | null,
      primaryPhone?: string | null,
      primaryPhoneType?: string | null,
      secondaryPhone?: string | null,
      secondaryPhoneType?: string | null,
      isActive?: boolean | null,
      isAlive?: boolean | null,
      eolVerificationCount?: number | null,
      lastEolVerificationResponseAt?: string | null,
      lastEolVerificationSentAt?: string | null,
      eolVerificationStatus?: EolVerificationStatus | null,
      currentEolVerificationCycleStartedAt?: string | null,
      lastEolVerificationMethod?: EolVerificationMethod | null,
      lastSuccessfulLoginAt?: string | null,
      Messages?:  {
        __typename: "ModelMessageConnection",
        nextToken?: string | null,
      } | null,
      Recipients?:  {
        __typename: "ModelRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    UserPreferences?:  {
      __typename: "UserPreferences",
      id: string,
      eolVerificationIntervalDays?: number | null,
      eolVerificationReminderCount?: number | null,
      eolVerificationReminderIntervalDays?: number | null,
      eolVerificationChannelEmailEnabled?: boolean | null,
      eolVerificationChannelSmsEnabled?: boolean | null,
      eolStopScheduledMessages?: boolean | null,
      minBodyWordCount?: number | null,
      eolAccountReaderRecipientId?: string | null,
      preferredLanguage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    billingProviderId?: string | null,
    userPlanId?: string | null,
    pendingPlanId?: string | null,
    scheduledPlanId?: string | null,
    planStatus?: string | null,
    planSelectedAt?: string | null,
    planActivatedAt?: string | null,
    checkoutSessionRef?: string | null,
    checkoutMode?: string | null,
    pendingPaymentAmount?: number | null,
    pendingPaymentQuotedAt?: string | null,
    latestPaymentId?: string | null,
    currentPeriodEnd?: string | null,
    billingProvider?: string | null,
    billingCustomerRef?: string | null,
    subscriptionId?: string | null,
    ChangeLogs?:  {
      __typename: "ModelChangeLogConnection",
      items:  Array< {
        __typename: "ChangeLog",
        id: string,
        requestId: string,
        changedById: string,
        userId: string,
        entityType: ChangeLogEntityType,
        entityId: string,
        changeType: ChangeLogChangeType,
        fieldName?: string | null,
        oldValue?: string | null,
        newValue?: string | null,
        metadata?: string | null,
        dateTime: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserProfileSubscriptionVariables = {
  filter?: ModelSubscriptionUserProfileFilterInput | null,
};

export type OnCreateUserProfileSubscription = {
  onCreateUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserProfileSubscriptionVariables = {
  filter?: ModelSubscriptionUserProfileFilterInput | null,
};

export type OnUpdateUserProfileSubscription = {
  onUpdateUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserProfileSubscriptionVariables = {
  filter?: ModelSubscriptionUserProfileFilterInput | null,
};

export type OnDeleteUserProfileSubscription = {
  onDeleteUserProfile?:  {
    __typename: "UserProfile",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    preferredName?: string | null,
    dateOfBirth?: string | null,
    primaryPhone?: string | null,
    primaryPhoneType?: string | null,
    secondaryPhone?: string | null,
    secondaryPhoneType?: string | null,
    isActive?: boolean | null,
    isAlive?: boolean | null,
    eolVerificationCount?: number | null,
    lastEolVerificationResponseAt?: string | null,
    lastEolVerificationSentAt?: string | null,
    eolVerificationStatus?: EolVerificationStatus | null,
    currentEolVerificationCycleStartedAt?: string | null,
    lastEolVerificationMethod?: EolVerificationMethod | null,
    lastSuccessfulLoginAt?: string | null,
    Messages?:  {
      __typename: "ModelMessageConnection",
      items:  Array< {
        __typename: "Message",
        id: string,
        title?: string | null,
        body: string,
        bodyIv?: string | null,
        bodyAuthTag?: string | null,
        bodyEncryptedDataKey?: string | null,
        bodySnippet?: string | null,
        status?: string | null,
        scheduledDate?: string | null,
        endOfLifeTrigger?: boolean | null,
        size?: number | null,
        userprofileID: string,
        sentDate?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Recipients?:  {
      __typename: "ModelRecipientConnection",
      items:  Array< {
        __typename: "Recipient",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email?: string | null,
        phone?: string | null,
        phoneType?: string | null,
        sendSMS?: boolean | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelAttachmentConnection",
      items:  Array< {
        __typename: "Attachment",
        id: string,
        name?: string | null,
        description?: string | null,
        type?: string | null,
        status?: string | null,
        size?: number | null,
        s3Key?: string | null,
        uploadDate?: string | null,
        userprofileID: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserPreferencesSubscriptionVariables = {
  filter?: ModelSubscriptionUserPreferencesFilterInput | null,
};

export type OnCreateUserPreferencesSubscription = {
  onCreateUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserPreferencesSubscriptionVariables = {
  filter?: ModelSubscriptionUserPreferencesFilterInput | null,
};

export type OnUpdateUserPreferencesSubscription = {
  onUpdateUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserPreferencesSubscriptionVariables = {
  filter?: ModelSubscriptionUserPreferencesFilterInput | null,
};

export type OnDeleteUserPreferencesSubscription = {
  onDeleteUserPreferences?:  {
    __typename: "UserPreferences",
    id: string,
    eolVerificationIntervalDays?: number | null,
    eolVerificationReminderCount?: number | null,
    eolVerificationReminderIntervalDays?: number | null,
    eolVerificationChannelEmailEnabled?: boolean | null,
    eolVerificationChannelSmsEnabled?: boolean | null,
    eolStopScheduledMessages?: boolean | null,
    minBodyWordCount?: number | null,
    eolAccountReaderRecipientId?: string | null,
    preferredLanguage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEolVerificationTokenSubscriptionVariables = {
  filter?: ModelSubscriptionEolVerificationTokenFilterInput | null,
};

export type OnCreateEolVerificationTokenSubscription = {
  onCreateEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEolVerificationTokenSubscriptionVariables = {
  filter?: ModelSubscriptionEolVerificationTokenFilterInput | null,
};

export type OnUpdateEolVerificationTokenSubscription = {
  onUpdateEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEolVerificationTokenSubscriptionVariables = {
  filter?: ModelSubscriptionEolVerificationTokenFilterInput | null,
};

export type OnDeleteEolVerificationTokenSubscription = {
  onDeleteEolVerificationToken?:  {
    __typename: "EolVerificationToken",
    id: string,
    userId: string,
    cycleId: string,
    tokenHash: string,
    status: EolVerificationTokenStatus,
    issuedAt: string,
    expiresAt: string,
    usedAt?: string | null,
    channel: EolVerificationChannel,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionRecipientFilterInput | null,
};

export type OnCreateRecipientSubscription = {
  onCreateRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionRecipientFilterInput | null,
};

export type OnUpdateRecipientSubscription = {
  onUpdateRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionRecipientFilterInput | null,
};

export type OnDeleteRecipientSubscription = {
  onDeleteRecipient?:  {
    __typename: "Recipient",
    id: string,
    firstName?: string | null,
    lastName?: string | null,
    email?: string | null,
    phone?: string | null,
    phoneType?: string | null,
    sendSMS?: boolean | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnCreateMessageSubscription = {
  onCreateMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnUpdateMessageSubscription = {
  onUpdateMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMessageSubscriptionVariables = {
  filter?: ModelSubscriptionMessageFilterInput | null,
};

export type OnDeleteMessageSubscription = {
  onDeleteMessage?:  {
    __typename: "Message",
    id: string,
    title?: string | null,
    body: string,
    bodyIv?: string | null,
    bodyAuthTag?: string | null,
    bodyEncryptedDataKey?: string | null,
    bodySnippet?: string | null,
    status?: string | null,
    scheduledDate?: string | null,
    endOfLifeTrigger?: boolean | null,
    size?: number | null,
    userprofileID: string,
    Recipients?:  {
      __typename: "ModelMessageRecipientConnection",
      items:  Array< {
        __typename: "MessageRecipient",
        id: string,
        recipientId: string,
        messageId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    Attachments?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sentDate?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnCreatePlanSubscription = {
  onCreatePlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnUpdatePlanSubscription = {
  onUpdatePlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePlanSubscriptionVariables = {
  filter?: ModelSubscriptionPlanFilterInput | null,
};

export type OnDeletePlanSubscription = {
  onDeletePlan?:  {
    __typename: "Plan",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    price?: number | null,
    billingCycle?: string | null,
    status?: string | null,
    messagesAllowed?: number | null,
    attachmentsAllowed?: number | null,
    recipientsAllowed?: number | null,
    billingProviderId?: string | null,
    checkoutMode?: string | null,
    priceId?: string | null,
    billingConfig?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBillingProviderSubscriptionVariables = {
  filter?: ModelSubscriptionBillingProviderFilterInput | null,
};

export type OnCreateBillingProviderSubscription = {
  onCreateBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBillingProviderSubscriptionVariables = {
  filter?: ModelSubscriptionBillingProviderFilterInput | null,
};

export type OnUpdateBillingProviderSubscription = {
  onUpdateBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBillingProviderSubscriptionVariables = {
  filter?: ModelSubscriptionBillingProviderFilterInput | null,
};

export type OnDeleteBillingProviderSubscription = {
  onDeleteBillingProvider?:  {
    __typename: "BillingProvider",
    id: string,
    billingProviderId?: string | null,
    billingProviderName?: string | null,
    providerCode?: string | null,
    isActive?: boolean | null,
    checkoutMode?: string | null,
    webhookEnabled?: boolean | null,
    apiBaseUrl?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnCreateAttachmentSubscription = {
  onCreateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnUpdateAttachmentSubscription = {
  onUpdateAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionAttachmentFilterInput | null,
};

export type OnDeleteAttachmentSubscription = {
  onDeleteAttachment?:  {
    __typename: "Attachment",
    id: string,
    name?: string | null,
    description?: string | null,
    type?: string | null,
    status?: string | null,
    size?: number | null,
    s3Key?: string | null,
    uploadDate?: string | null,
    userprofileID: string,
    messages?:  {
      __typename: "ModelMessageAttachmentConnection",
      items:  Array< {
        __typename: "MessageAttachment",
        id: string,
        messageId: string,
        attachmentId: string,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateChangeLogSubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogFilterInput | null,
};

export type OnCreateChangeLogSubscription = {
  onCreateChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateChangeLogSubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogFilterInput | null,
};

export type OnUpdateChangeLogSubscription = {
  onUpdateChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteChangeLogSubscriptionVariables = {
  filter?: ModelSubscriptionChangeLogFilterInput | null,
};

export type OnDeleteChangeLogSubscription = {
  onDeleteChangeLog?:  {
    __typename: "ChangeLog",
    id: string,
    requestId: string,
    changedById: string,
    userId: string,
    entityType: ChangeLogEntityType,
    entityId: string,
    changeType: ChangeLogChangeType,
    fieldName?: string | null,
    oldValue?: string | null,
    newValue?: string | null,
    metadata?: string | null,
    dateTime: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLegalAcceptanceSubscriptionVariables = {
  filter?: ModelSubscriptionLegalAcceptanceFilterInput | null,
};

export type OnCreateLegalAcceptanceSubscription = {
  onCreateLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLegalAcceptanceSubscriptionVariables = {
  filter?: ModelSubscriptionLegalAcceptanceFilterInput | null,
};

export type OnUpdateLegalAcceptanceSubscription = {
  onUpdateLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLegalAcceptanceSubscriptionVariables = {
  filter?: ModelSubscriptionLegalAcceptanceFilterInput | null,
};

export type OnDeleteLegalAcceptanceSubscription = {
  onDeleteLegalAcceptance?:  {
    __typename: "LegalAcceptance",
    id: string,
    userId: string,
    version: string,
    acceptedAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateLoginEventSubscriptionVariables = {
  filter?: ModelSubscriptionLoginEventFilterInput | null,
};

export type OnCreateLoginEventSubscription = {
  onCreateLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateLoginEventSubscriptionVariables = {
  filter?: ModelSubscriptionLoginEventFilterInput | null,
};

export type OnUpdateLoginEventSubscription = {
  onUpdateLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteLoginEventSubscriptionVariables = {
  filter?: ModelSubscriptionLoginEventFilterInput | null,
};

export type OnDeleteLoginEventSubscription = {
  onDeleteLoginEvent?:  {
    __typename: "LoginEvent",
    id: string,
    userId: string,
    eventType: LoginEventType,
    occurredAt: string,
    sessionId: string,
    sourceApp: string,
    clientType: LoginClientType,
    browser: string,
    os: string,
    userAgent: string,
    authMethod: string,
    mfaUsed: boolean,
    ipHash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateBillingEventLogSubscriptionVariables = {
  filter?: ModelSubscriptionBillingEventLogFilterInput | null,
};

export type OnCreateBillingEventLogSubscription = {
  onCreateBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateBillingEventLogSubscriptionVariables = {
  filter?: ModelSubscriptionBillingEventLogFilterInput | null,
};

export type OnUpdateBillingEventLogSubscription = {
  onUpdateBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteBillingEventLogSubscriptionVariables = {
  filter?: ModelSubscriptionBillingEventLogFilterInput | null,
};

export type OnDeleteBillingEventLogSubscription = {
  onDeleteBillingEventLog?:  {
    __typename: "BillingEventLog",
    id: string,
    userId: string,
    provider: string,
    providerEventId: string,
    providerCustomerRef?: string | null,
    providerResourceRef?: string | null,
    eventType: string,
    status: string,
    planId?: string | null,
    amount?: number | null,
    currency?: string | null,
    occurredAt?: string | null,
    receivedAt: string,
    processedAt?: string | null,
    message?: string | null,
    rawPayload?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMessageRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionMessageRecipientFilterInput | null,
};

export type OnCreateMessageRecipientSubscription = {
  onCreateMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMessageRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionMessageRecipientFilterInput | null,
};

export type OnUpdateMessageRecipientSubscription = {
  onUpdateMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMessageRecipientSubscriptionVariables = {
  filter?: ModelSubscriptionMessageRecipientFilterInput | null,
};

export type OnDeleteMessageRecipientSubscription = {
  onDeleteMessageRecipient?:  {
    __typename: "MessageRecipient",
    id: string,
    recipientId: string,
    messageId: string,
    recipient:  {
      __typename: "Recipient",
      id: string,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      phone?: string | null,
      phoneType?: string | null,
      sendSMS?: boolean | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMessageAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionMessageAttachmentFilterInput | null,
};

export type OnCreateMessageAttachmentSubscription = {
  onCreateMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMessageAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionMessageAttachmentFilterInput | null,
};

export type OnUpdateMessageAttachmentSubscription = {
  onUpdateMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMessageAttachmentSubscriptionVariables = {
  filter?: ModelSubscriptionMessageAttachmentFilterInput | null,
};

export type OnDeleteMessageAttachmentSubscription = {
  onDeleteMessageAttachment?:  {
    __typename: "MessageAttachment",
    id: string,
    messageId: string,
    attachmentId: string,
    message:  {
      __typename: "Message",
      id: string,
      title?: string | null,
      body: string,
      bodyIv?: string | null,
      bodyAuthTag?: string | null,
      bodyEncryptedDataKey?: string | null,
      bodySnippet?: string | null,
      status?: string | null,
      scheduledDate?: string | null,
      endOfLifeTrigger?: boolean | null,
      size?: number | null,
      userprofileID: string,
      Recipients?:  {
        __typename: "ModelMessageRecipientConnection",
        nextToken?: string | null,
      } | null,
      Attachments?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      sentDate?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    attachment:  {
      __typename: "Attachment",
      id: string,
      name?: string | null,
      description?: string | null,
      type?: string | null,
      status?: string | null,
      size?: number | null,
      s3Key?: string | null,
      uploadDate?: string | null,
      userprofileID: string,
      messages?:  {
        __typename: "ModelMessageAttachmentConnection",
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};
